import { useVeltClient, VeltComments, VeltRecorderTool, VeltCommentBubble, VeltRecorderControlPanel, VeltRecorderPlayer, VeltHuddleTool, VeltCommentTool } from '@veltdev/react';
import { useEffect, useState } from 'react';
import YourAuthComponent from './YourAuthComponent';

import "./Table.css"

export default function YourDocument() {

  // Get the Velt client
  const { client } = useVeltClient();



  useEffect(() => {
    if (client) {
      // Set a document ID
      client.setDocumentId('unique-document-id-product-board-demo-table');
      let commentElement = client.getCommentElement()
      commentElement.enablePopoverMode();

    }
  }, [client]);

  return (
    <>
    <VeltComments popoverMode={true}/>
  <meta
    httpEquiv="Content-Security-Policy"
    content="base-uri optimize.google.com; object-src 'none'; script-src 'self' cdn.productboard.com blob: *.stripe.com use.typekit.net *.jquery.com unpkg.com/es6-promise@4.1.0/dist/es6-promise.min.js unpkg.com/whatwg-fetch@2.0.3/fetch.js ana-api.productboard.com ana-cdn.productboard.com *.intercom.io *.intercomcdn.com cdn.sprig.com google-analytics.com www.google-analytics.com www.googletagmanager.com www.googleadservices.com www.google.com optimize.google.com *.doubleclick.net cdn.heapanalytics.com heapanalytics.com cdn.mxpnl.com connect.facebook.net *.wistia.com *.wistia.net src.litix.io/core/2/mux.js *.hotjar.com *.ads-twitter.com *.licdn.com *.linkedin.com *.twitter.com d3pkntwtp2ukl5.cloudfront.net/uba.js t.unbounce.com pi.pardot.com *.clearbit.com clearbitjs.com *.marketo.net *.marketo.com *.productboard.com cdn.madkudu.com ajax.cloudflare.com/cdn-cgi/scripts/7089c43e/cloudflare-static/rocket-loader.min.js *.zdassets.com *.6sc.co *.dopt.com 'nonce-ANg67q0VBCLYaERjUEmGMQ==' 'nonce-sZvTUdJpCqzmaI2rkg6whQ==' 'nonce-NVfokFmRHbT+b4jz/xz4WQ==' 'nonce-qBBV+Yjg4FDFAf6nZTpAoA==' 'nonce-3FJAd2H9/8R1MOSO7z+foA==' 'nonce-Qy5kBdfmSCD/BUPlxQFvJw==' 'nonce-tby/GEyTSm3c7XvnFvx4IA==' 'strict-dynamic'; style-src 'self' 'unsafe-inline' cdnjs.cloudflare.com use.typekit.net p.typekit.net cdn.productboard.com heapanalytics.com maxcdn.bootstrapcdn.com *.marketo.com info.productboard.com optimize.google.com; default-src 'self'; font-src 'self' cdn.productboard.com data: use.typekit.net fonts.typekit.net *.intercomcdn.com *.wistia.com heapanalytics.com maxcdn.bootstrapcdn.com; frame-src *.stripe.com *.wistia.com *.wistia.net *.vimeo.com *.youtube.com *.doubleclick.net *.productboard.com *.marketo.com optimize.google.com *.hotjar.com intercom-sheets.com intercom-reporting.com *.loom.com miro.com *.miro.com *.figma.com *.mural.co; child-src *.stripe.com *.wistia.com *.wistia.net *.vimeo.com *.youtube.com *.doubleclick.net *.productboard.com *.marketo.com optimize.google.com *.hotjar.com intercom-sheets.com intercom-reporting.com *.loom.com miro.com *.miro.com *.figma.com *.mural.co; form-action https://intercom.help https://api-iam.intercom.io *.productboard.com *.productboard.info; img-src * data: blob: heapanalytics.com https://js.intercomcdn.com https://static.intercomassets.com https://downloads.intercomcdn.com https://downloads.intercomcdn.eu https://downloads.au.intercomcdn.com https://uploads.intercomusercontent.com https://gifs.intercomcdn.com  https://video-messages.intercomcdn.com https://messenger-apps.intercom.io https://messenger-apps.eu.intercom.io https://messenger-apps.au.intercom.io https://*.intercom-attachments-1.com https://*.intercom-attachments.eu https://*.au.intercom-attachments.com https://*.intercom-attachments-2.com https://*.intercom-attachments-3.com https://*.intercom-attachments-4.com https://*.intercom-attachments-5.com https://*.intercom-attachments-6.com https://*.intercom-attachments-7.com https://*.intercom-attachments-8.com https://*.intercom-attachments-9.com https://static.intercomassets.eu https://static.au.intercomassets.com; connect-src 'self' 'self' blob: cdn.productboard.com nucleus.productboard.net *.pusher.com wss://ws.pusherapp.com:443 wss://ws.pusherapp.com wss://ws-eu.pusherapp.com:443 wss://ws-eu.pusherapp.com wss://ws-eu.pusher.com wss://ws-mt1.pusher.com ana-api.productboard.com *.segment.com api.intercom.io api.au.intercom.io api.eu.intercom.io api-iam.intercom.io api-iam.eu.intercom.io api-iam.au.intercom.io  api-ping.intercom.io   nexus-websocket-a.intercom.io wss://nexus-websocket-a.intercom.io nexus-websocket-b.intercom.io wss://nexus-websocket-b.intercom.io nexus-europe-websocket.intercom.io  wss://nexus-europe-websocket.intercom.io  nexus-australia-websocket.intercom.io wss://nexus-australia-websocket.intercom.io  uploads.intercomcdn.com uploads.intercomcdn.eu  uploads.au.intercomcdn.com  uploads.intercomusercontent.com  *.intercomcdn.com api.sprig.com vc.hotjar.io *.typekit.net api.mixpanel.com *.wistia.com *.wistia.net *.facebook.com api.trello.com embedwistia-a.akamaihd.net heapanalytics.com *.googlesyndication.com *.google.com www.google-analytics.com *.litix.io *.clearbit.com *.mktoresp.com *.launchdarkly.com api.honeycomb.io *.hotjar.com wss://*.hotjar.com *.ingest.sentry.io *.doubleclick.net *.browser-intake-datadoghq.com https://api.amplitude.com https://api2.amplitude.com *.zdassets.com widget-mediator.zopim.com wss://widget-mediator.zopim.com productboard.zendesk.com *.6sc.co *.adnxs.com *.loom.com app.satismeter.com *.dopt.com wss://*.dopt.com; media-src 'self' data: blob: *.intercomcdn.com embedwistia-a.akamaihd.net *.wistia.com cdn.productboard.com nucleus.productboard.net *.zdassets.com cdn.loom.com; worker-src 'self' blob:"
  />
  <meta charSet="utf-8" />
  <meta name="referrer" content="origin" />
  <title>Feature prioritization (sample) | Productboard</title>
  <meta
    name="description"
    content="Get the right products to market, faster."
  />
  <meta property="og:title" content="Productboard" />
  <meta
    property="og:description"
    content="Get the right products to market, faster."
  />
  <meta name="revision" content="f38081175c15cbc50246e3ccf9385cec74109b55" />
  <section id="react" className="is-viewer">
    <div className="animated-componentstyled__fade-sc-12t1a22-0 hkNeWR appear-done enter-done">
      <div className="application-content__ApplicationContainer-sc-1k5swnc-0 fRmFgP">
        <div className="application-content__Application-sc-1k5swnc-1 gaQKLZ">
          <div className="main-menu-expand-button__Container-sc-a3nm2x-0 lfcfkH">
            <div className="box__StyledBox-sc-b30x7m-0 huKWQq">
              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                <button
                  type="button"
                  aria-label="Collapse menu"
                  data-nc="true"
                  data-testid="Header-MenuButton"
                  className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                >
                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                    <svg
                      height="16px"
                      width="16px"
                      viewBox="0 0 16 16"
                      role="img"
                      aria-label="CollapseNavigationIcon"
                      className="sc-11y93t1-0 dqXaRM ui-icon"
                    >
                      <path
                        d="M8 2h6v2H8V2ZM14 12H8v2h6v-2ZM14 7H8v2h6V7Z"
                        fill="currentColor"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m.317 7.221 3.831-3.897a1.07 1.07 0 0 1 1.533 0c.423.43.423 1.128 0 1.558L2.616 8l3.065 3.118a1.117 1.117 0 0 1 0 1.56c-.423.43-1.11.43-1.533 0L.318 8.78a1.116 1.116 0 0 1 0-1.559Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </button>
              </span>
            </div>
          </div>
          <header width={256} className="main-menu__Header-sc-1px38at-0 ddVgTE">
            <div
              style={{
                position: "relative",
                userSelect: "auto",
                width: 256,
                height: "100%",
                maxWidth: 480,
                minWidth: 240,
                boxSizing: "border-box",
                flexShrink: 0
              }}
            >
              <div className="flexstyled__StyledFlex-sc-lvlevv-0 jNTZsy">
                <div
                  data-testid="Account-Menu"
                  className="header__Trigger-sc-msz0fa-1 jQTgDt"
                >
                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 eqxftF">
                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 gCQyQp">
                      <svg
                        height="20px"
                        viewBox="0 0 162 108"
                        data-testid="AppHeader-Logo"
                        data-nc="true"
                      >
                        <path
                          fill="#0071E1"
                          d="M108.001 0L162 54l-54.001 54-53.996-54L108 0z"
                        />
                        <path
                          fill="#FFC600"
                          d="M107.997 0L53.999 54 0 0h107.997z"
                        />
                        <path
                          fill="#F84136"
                          d="M53.999 54l53.998 54H0l53.999-54z"
                        />
                      </svg>
                    </div>
                    <div
                      data-nc="true"
                      className="heading__StyledHeading-sc-114dp0l-0 XDuDU"
                    >
                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                        <span className="header__HeadingWrapper-sc-msz0fa-0 gcTzuh">
                          <YourAuthComponent/>
                        </span>
                      </span>
                    </div>
                    <svg
                      height="16px"
                      width="16px"
                      viewBox="0 0 16 16"
                      role="img"
                      aria-label="ArrowCaretIcon"
                      className="sc-11y93t1-0 xIpMQ ui-icon"
                    >
                      <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M5.25 7.495C4.75 6.997 5 6 6 6h3.995c1.005 0 1.256.995.755 1.495l-2 2.205c-.45.4-1.05.4-1.498 0L5.25 7.495z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="flexstyled__StyledFlex-sc-lvlevv-0 jaLSkS">
                <div className="quickfind__Container-sc-b1ll48-0 eZSrsz">
                  <div className="menu-item__Item-sc-18xys5o-1 jwMyEu">
                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                      <svg
                        height="16px"
                        width="16px"
                        viewBox="0 0 16 16"
                        role="img"
                        aria-label="SearchIcon"
                        className="sc-11y93t1-0 kqDcRj ui-icon"
                      >
                        <path
                          fill="currentColor"
                          fillRule="evenodd"
                          d="M15.546 15.546a1.5 1.5 0 0 1-2.121 0l-2.647-2.647a6.945 6.945 0 0 1-3.763 1.115 7 7 0 0 1 0-13.999 6.998 6.998 0 0 1 6.999 6.999 6.953 6.953 0 0 1-1.114 3.764l2.647 2.648a1.5 1.5 0 0 1-.001 2.12zM7.014 2.014a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 gNrzLm">
                        <div className="menu-item__Label-sc-18xys5o-0 fTajIn">
                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                            <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                              <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                <span
                                  data-testid="Quickfind-MenuItem"
                                  data-nc="true"
                                  className="textstyled__StyledText-sc-cx1866-0 kURyuR"
                                >
                                  Find board
                                </span>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-testid="Quickfind-Modal" />
                </div>
                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 gyXsuf">
                  <button
                    type="button"
                    aria-label="Notifications"
                    data-nc="true"
                    data-testid="NotificationCenter-Button"
                    className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                  >
                    <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                      <div className="sc-1bp6zuu-0 dqbDkO">
                        <svg
                          height="16px"
                          width="16px"
                          viewBox="0 0 16 16"
                          role="img"
                          aria-label="NotificationIcon"
                          className="sc-11y93t1-0 xIpMQ ui-icon"
                        >
                          <path
                            fill="currentColor"
                            fillRule="evenodd"
                            d="M15 11.999h-1V8c0-3.589-3.725-8-6-8S2 4.411 2 8v3.999H1A1 1 0 0 0 1 14h4c0 1.104 1.343 2 3 2 1.656 0 3-.896 3-2h4a1 1 0 0 0 0-2.001zm-11 0v-3C4 5.208 6.987 2 8 2s3.999 3.333 3.999 6.999v3H4z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    </div>
                  </button>
                </span>
              </div>
              <div
                data-testid="main-menu-scroll-container"
                className="main-menu__ScrollContainer-sc-1px38at-1 cEGlbj"
              >
                <div className="scroll-shadow__StyledScrollShadow-sc-19nlq98-0 dWqUOp main-menu___StyledScrollShadow-sc-1px38at-4 iQrqyW">
                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jFTdor main-menu___StyledFlex-sc-1px38at-5 ihhPDO">
                    <div className="main-menu__ScrollContainerContent-sc-1px38at-2 ewMtvs">
                      <div
                        className="flexstyled__StyledFlex-sc-lvlevv-0 jbiJGI"
                        data-testid="StaticMenu"
                      >
                        <div className="static-menu-itemstyled__HomeStaticItemContainer-sc-jveuem-0 emwIkj">
                          <a
                            data-testid="StaticMenuItem"
                            tabIndex={0}
                            data-nc="true"
                            className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                            href="/home"
                          >
                            <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                      <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                        <svg
                                          height="16px"
                                          width="16px"
                                          viewBox="0 0 16 16"
                                          role="img"
                                          aria-label="HomeIcon"
                                          className="sc-11y93t1-0 xIpMQ ui-icon"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6 10.03c-.6 0-1 .4-1 1v3H3v-7.5l5-4.2 5 4.2v7.5h-2v-3c0-.6-.4-1-1-1H6ZM10 16h4c.6 0 1-.4 1-1V6.03c0-.3-.1-.6-.4-.8l-6-5c-.4-.3-.9-.3-1.3 0l-6 5c-.2.2-.3.5-.3.8V15c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-2.97h2V15c0 .6.4 1 1 1Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                    <div
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                    >
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                              <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                Home
                                              </div>
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                      <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <a
                          data-testid="StaticMenuItem"
                          tabIndex={0}
                          data-nc="true"
                          className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                          href="/teamspaces/all"
                        >
                          <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                    <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="AllTeamspacesIcon"
                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                      >
                                        <path
                                          d="M2 2a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H2ZM2 7a1 1 0 0 0 0 2h3.59c.134-.727.41-1.403.8-2H2ZM5.875 12a5.508 5.508 0 0 0 1.35 2H2a1 1 0 1 1 0-2h3.875Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M12.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.165 3.08a3.5 3.5 0 1 1 1.414-1.414l1.163 1.162a1 1 0 1 1-1.414 1.414l-1.163-1.163Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                  <div
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                  >
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                          <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                            <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                              All teamspaces
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                    <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                        <div
                          data-testid="MainMenuSection-Favorites"
                          className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                        >
                          <div
                            className="a6XhA2vk2hktu_NcQWh7"
                            role="heading"
                            data-testid="Group-Heading"
                          >
                            Favorites
                          </div>
                          <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                            <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="ChevronRightIcon"
                                className="sc-11y93t1-0 xIpMQ ui-icon"
                              >
                                <path
                                  fill="currentColor"
                                  fillRule="evenodd"
                                  d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        display="flex"
                        className="box__StyledBox-sc-b30x7m-0 latrRT"
                      >
                        <span
                          data-nc="true"
                          className="textstyled__StyledText-sc-cx1866-0 dOIxr"
                        >
                          No boards yet
                        </span>
                      </div>
                      <div className="navigation-sections__Wrapper-sc-ng4kon-0 evgVDh">
                        <div className="navigation-teamspace-coachmark__AttachableCoachmarkPlaceholder-sc-4bu7ey-0 dNoCXR" />
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                          <div
                            data-testid="MainMenuSection-Teamspaces"
                            className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                          >
                            <div
                              className="a6XhA2vk2hktu_NcQWh7"
                              role="heading"
                              data-testid="Group-Heading"
                            >
                              Teamspaces
                            </div>
                            <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                              <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                                <svg
                                  height="16px"
                                  width="16px"
                                  viewBox="0 0 16 16"
                                  role="img"
                                  aria-label="ChevronRightIcon"
                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                >
                                  <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 hqdVxL">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                              <a href="/teamspaces/all">
                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                  <button
                                    type="button"
                                    aria-label="All teamspaces"
                                    data-nc="true"
                                    data-testid="all-team-spaces-button"
                                    className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                  >
                                    <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="AllTeamspacesIcon"
                                        className="sc-11y93t1-0 dqXaRM ui-icon"
                                      >
                                        <path
                                          d="M2 2a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H2ZM2 7a1 1 0 0 0 0 2h3.59c.134-.727.41-1.403.8-2H2ZM5.875 12a5.508 5.508 0 0 0 1.35 2H2a1 1 0 1 1 0-2h3.875Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M12.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.165 3.08a3.5 3.5 0 1 1 1.414-1.414l1.163 1.162a1 1 0 1 1-1.414 1.414l-1.163-1.163Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </div>
                                  </button>
                                </span>
                              </a>
                            </div>
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                              <div className="pull__StyledPull-sc-9ujoh3-0 hnawlo">
                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                  <button
                                    type="button"
                                    aria-label="Create a new teamspace"
                                    data-nc="true"
                                    data-testid="create-teamspace-section-button"
                                    className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                  >
                                    <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="PlusCircleIcon"
                                        className="sc-11y93t1-0 dqXaRM ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M8 .001a8 8 0 1 0 0 15.998A8 8 0 1 0 8 .001zm0 13.998A6.006 6.006 0 0 1 1.999 8 6.006 6.006 0 0 1 8 2.001c3.308 0 6 2.69 6 5.999a6.006 6.006 0 0 1-6 5.999zM11.01 7H8.999V4.99A.989.989 0 0 0 8.01 4h-.021A.99.99 0 0 0 7 4.99V7H4.99a.99.99 0 0 0-.99.99v.02c0 .547.443.99.99.99H7v2.01c0 .547.443.99.989.99h.021a.989.989 0 0 0 .989-.99V9h2.011a.99.99 0 0 0 .99-.99v-.02a.99.99 0 0 0-.99-.99z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          display="inherit"
                          className="box__StyledBox-sc-b30x7m-0 dYVUUv"
                        >
                          <div className="list-headlessstyled__Wrapper-sc-ca3ui9-2 ckltsV">
                            <div className="list-headlessstyled__StyledListContainer-sc-ca3ui9-0 lhqdBH">
                              <ul
                                data-testid="TeamspacesNavigationSection"
                                role="listbox"
                                className="list-headlessstyled__StyledList-sc-ca3ui9-1 cejUwb"
                              >
                                <li data-spacer="true" style={{ height: 4 }} />
                                <li
                                  data-index={0}
                                  data-id="MTpUZWFtc3BhY2U6MmY1YjU5NzctMjBjZC00YzVlLWJkNWItMWExM2IwM2E4ODkx"
                                  role="presentation"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="TeamspaceItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 fxmTMQ"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 iHfdzr">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="TeamspaceIcon"
                                                    className="sc-11y93t1-0 cRyrkY ui-icon"
                                                  >
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M3.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-9 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                                                      fill=""
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M12 4c-1.2 0-2.2.5-2.9 1.3L6.9 4.2c.1-.2.1-.5.1-.7C7 1.6 5.4 0 3.5 0S0 1.6 0 3.5c0 1.4.8 2.6 2 3.1v2.7c-1.2.6-2 1.8-2 3.1 0 2 1.6 3.6 3.5 3.6S7 14.4 7 12.5c0-.2 0-.5-.1-.7L9 10.7c.8.8 1.8 1.3 3 1.3 2.2 0 4-1.8 4-4s-1.8-4-4-4ZM3.5 2C4.3 2 5 2.7 5 3.5S4.3 5 3.5 5 2 4.3 2 3.5 2.7 2 3.5 2Zm0 12c-.8 0-1.5-.7-1.5-1.5S2.7 11 3.5 11s1.5.7 1.5 1.5S4.3 14 3.5 14ZM6 10c-.5-.5-1.2-.9-2-1V6.9c.8-.1 1.5-.5 2-1L8.1 7c-.1.7-.1 1.3 0 1.9L6 10Zm6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpUZWFtc3BhY2U6MmY1YjU5NzctMjBjZC00YzVlLWJkNWItMWExM2IwM2E4ODkx"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          General
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <div
                                                    display="flex"
                                                    className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                  >
                                                    <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="DotsIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="add-Generalboard-left-nav"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="PlusIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </div>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={1}
                                  data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOmYxYTZhNGIzLTQ3MmMtNDYwNS04ZDgyLTU4Mzc3YzI2YTczOA=="
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="FolderItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 bocYtX"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 dUZVXr">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="TeamspaceFolderOpenIcon"
                                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                                  >
                                                    <path
                                                      fill=""
                                                      d="M2 2h11v5H2z"
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M2 0C1.473 0 .956.18.568.568.18.956 0 1.473 0 2v12a1 1 0 1 0 2 0V2h5.986l.007.007 1.7 1.7A1 1 0 0 0 10.4 4H13v2a1 1 0 1 0 2 0V4c0-.527-.18-1.044-.568-1.432C14.044 2.18 13.527 2 13 2h-2.186L9.407.593A2.034 2.034 0 0 0 8.794.16 1.93 1.93 0 0 0 8 0H2Z"
                                                      fill="currentColor"
                                                    />
                                                    <path
                                                      d="M3 6h12l-2 8H1l2-8Z"
                                                      fill=""
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M2.03 5.757A1 1 0 0 1 3 5h12a1 1 0 0 1 .97 1.243l-2 8A1 1 0 0 1 13 15H1a1 1 0 0 1-.97-1.242l2-8ZM3.78 7l-1.5 6h9.94l1.5-6H3.78Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uRm9sZGVyOmYxYTZhNGIzLTQ3MmMtNDYwNS04ZDgyLTU4Mzc3YzI2YTczOA=="
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feature boards
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <div
                                                    display="flex"
                                                    className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                  >
                                                    <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="Folder-ContextMenu"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="DotsIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="add-Feature boardsboard-left-nav"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="PlusIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </div>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={2}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6M2YwYTA2NzItMTAwZi00MjRjLTg3ODQtZTM2OTYwMDJlODNm"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/feature-board/7450405-feature-planning-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="FeaturesBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6M2YwYTA2NzItMTAwZi00MjRjLTg3ODQtZTM2OTYwMDJlODNm"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feature planning
                                                          (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                                <li
                                  data-index={3}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NjlkMjJjMGItYWEzYi00NTUxLTg1YmEtN2VhN2ViMjNhMThl"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/feature-board/7450406-feature-prioritization-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 krOJcX">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="FeaturesBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6NjlkMjJjMGItYWEzYi00NTUxLTg1YmEtN2VhN2ViMjNhMThl"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feature prioritization
                                                          (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                                <li
                                  data-index={4}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NzkwNTBiOTMtMDEwNi00YzI1LWFhZjUtZGY5ZTVhOWFkNWY1"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="BoardItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 hSQxpg"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 zsdBX">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="FeaturesBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feedback-driven
                                                          prioritization
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz">
                                                  <div className="premium-badgestyled__FusionBadgeContainer-sc-f89j6e-1 dRDqqN">
                                                    <svg
                                                      height="12px"
                                                      width="12px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="UpgradeIcon"
                                                      className="sc-11y93t1-0 gwBFtq ui-icon"
                                                    >
                                                      <path
                                                        d="M16 10.5c0-1-.839-1.338-1.75-1.75-.964-.435-1.516-.988-2-2C11.819 5.848 11.5 5 10.5 5s-1.355.831-1.75 1.75c-.435 1.012-.988 1.565-2 2C5.831 9.145 5 9.5 5 10.5s.848 1.319 1.75 1.75c1.012.484 1.565 1.036 2 2 .435.964.75 1.75 1.75 1.75s1.266-.786 1.75-1.75 1.036-1.516 2-2S16 11.5 16 10.5zM6 3c0-.545-.457-.73-.955-.955-.525-.237-.826-.538-1.09-1.09C3.719.462 3.545 0 3 0c-.545 0-.739.453-.955.955-.237.552-.538.853-1.09 1.09C.453 2.261 0 2.455 0 3c0 .545.462.72.955.955.552.264.853.565 1.09 1.09.238.526.41.955.955.955.545 0 .69-.429.955-.955.264-.525.565-.826 1.09-1.09C5.571 3.69 6 3.545 6 3z"
                                                        fill="currentColor"
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                      />
                                                    </svg>
                                                    <div className="premium-badgestyled__PlanNameContainer-sc-f89j6e-0 YzjNY">
                                                      <span
                                                        data-nc="true"
                                                        className="textstyled__StyledText-sc-cx1866-0 fCUahr"
                                                      >
                                                        Pro
                                                      </span>
                                                    </div>
                                                  </div>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={5}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NDBjYjViYTMtNTE0MC00ZDdmLTllZTktNGFhNTNmMDkwMGU2"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="BoardItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 hSQxpg"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 zsdBX">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="FeaturesBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Objective-driven
                                                          prioritization
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz">
                                                  <div className="premium-badgestyled__FusionBadgeContainer-sc-f89j6e-1 dRDqqN">
                                                    <svg
                                                      height="12px"
                                                      width="12px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="UpgradeIcon"
                                                      className="sc-11y93t1-0 gwBFtq ui-icon"
                                                    >
                                                      <path
                                                        d="M16 10.5c0-1-.839-1.338-1.75-1.75-.964-.435-1.516-.988-2-2C11.819 5.848 11.5 5 10.5 5s-1.355.831-1.75 1.75c-.435 1.012-.988 1.565-2 2C5.831 9.145 5 9.5 5 10.5s.848 1.319 1.75 1.75c1.012.484 1.565 1.036 2 2 .435.964.75 1.75 1.75 1.75s1.266-.786 1.75-1.75 1.036-1.516 2-2S16 11.5 16 10.5zM6 3c0-.545-.457-.73-.955-.955-.525-.237-.826-.538-1.09-1.09C3.719.462 3.545 0 3 0c-.545 0-.739.453-.955.955-.237.552-.538.853-1.09 1.09C.453 2.261 0 2.455 0 3c0 .545.462.72.955.955.552.264.853.565 1.09 1.09.238.526.41.955.955.955.545 0 .69-.429.955-.955.264-.525.565-.826 1.09-1.09C5.571 3.69 6 3.545 6 3z"
                                                        fill="currentColor"
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                      />
                                                    </svg>
                                                    <div className="premium-badgestyled__PlanNameContainer-sc-f89j6e-0 YzjNY">
                                                      <span
                                                        data-nc="true"
                                                        className="textstyled__StyledText-sc-cx1866-0 fCUahr"
                                                      >
                                                        Enterprise
                                                      </span>
                                                    </div>
                                                  </div>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={6}
                                  data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOjZmZWFmYmI5LTU2YWYtNDc5OC1iMzZlLTQ2N2YyMWQyOGYzZA=="
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="FolderItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 bocYtX"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 dUZVXr">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="TeamspaceFolderOpenIcon"
                                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                                  >
                                                    <path
                                                      fill=""
                                                      d="M2 2h11v5H2z"
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M2 0C1.473 0 .956.18.568.568.18.956 0 1.473 0 2v12a1 1 0 1 0 2 0V2h5.986l.007.007 1.7 1.7A1 1 0 0 0 10.4 4H13v2a1 1 0 1 0 2 0V4c0-.527-.18-1.044-.568-1.432C14.044 2.18 13.527 2 13 2h-2.186L9.407.593A2.034 2.034 0 0 0 8.794.16 1.93 1.93 0 0 0 8 0H2Z"
                                                      fill="currentColor"
                                                    />
                                                    <path
                                                      d="M3 6h12l-2 8H1l2-8Z"
                                                      fill=""
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M2.03 5.757A1 1 0 0 1 3 5h12a1 1 0 0 1 .97 1.243l-2 8A1 1 0 0 1 13 15H1a1 1 0 0 1-.97-1.242l2-8ZM3.78 7l-1.5 6h9.94l1.5-6H3.78Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uRm9sZGVyOjZmZWFmYmI5LTU2YWYtNDc5OC1iMzZlLTQ2N2YyMWQyOGYzZA=="
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Roadmaps
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <div
                                                    display="flex"
                                                    className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                  >
                                                    <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="Folder-ContextMenu"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="DotsIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="add-Roadmapsboard-left-nav"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="PlusIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </div>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={7}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6MzBmMTM0MjAtOTg4Yy00Nzg4LWEyMmUtY2Y1YWI1MjA4NmJh"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/roadmap/7450412-feature-launch-roadmap-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="RoadmapBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6MzBmMTM0MjAtOTg4Yy00Nzg4LWEyMmUtY2Y1YWI1MjA4NmJh"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feature launch roadmap
                                                          (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                                <li
                                  data-index={8}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6OTFhZGQ1OTQtMjM3Ni00ZWU4LThhMGYtMDNiNWRkMzNkYTNl"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/roadmap/7450409-kanban-roadmap-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="RoadmapBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6OTFhZGQ1OTQtMjM3Ni00ZWU4LThhMGYtMDNiNWRkMzNkYTNl"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Kanban roadmap
                                                          (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                                <li
                                  data-index={9}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NTNmYjU1ZDctNjhhNC00ODhlLTk4ZWItNTFjYWE2OTA1MTdm"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/roadmap/7450410-sprint-roadmap-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="RoadmapBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6NTNmYjU1ZDctNjhhNC00ODhlLTk4ZWItNTFjYWE2OTA1MTdm"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Sprint roadmap
                                                          (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                                <li
                                  data-index={10}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6OWY4YjRmYTUtYWZjYi00M2IwLWI1ZmMtZDU0NDYyZjk3MmRh"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/roadmap/7450411-features-timeline-roadmap-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="RoadmapBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6OWY4YjRmYTUtYWZjYi00M2IwLWI1ZmMtZDU0NDYyZjk3MmRh"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Features timeline
                                                          roadmap (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                              </ul>
                              <div
                                data-testid="ListHeadless-KeyboardAnchor"
                                tabIndex={0}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                          <div
                            data-testid="MainMenuSection-Personal"
                            className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                          >
                            <div
                              className="a6XhA2vk2hktu_NcQWh7"
                              role="heading"
                              data-testid="Group-Heading"
                            >
                              Personal
                            </div>
                            <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                              <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                                <svg
                                  height="16px"
                                  width="16px"
                                  viewBox="0 0 16 16"
                                  role="img"
                                  aria-label="ChevronRightIcon"
                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                >
                                  <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div className="pull__StyledPull-sc-9ujoh3-0 hnawlo">
                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                              <button
                                type="button"
                                aria-label="Show more"
                                data-nc="true"
                                data-testid="add-Personalboard-left-nav"
                                className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                              >
                                <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="PlusIcon"
                                    className="sc-11y93t1-0 dqXaRM ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </button>
                            </span>
                          </div>
                        </div>
                        <div
                          display="inherit"
                          className="box__StyledBox-sc-b30x7m-0 dYVUUv"
                        >
                          <div className="list-headlessstyled__Wrapper-sc-ca3ui9-2 ckltsV">
                            <div className="list-headlessstyled__StyledListContainer-sc-ca3ui9-0 lhqdBH">
                              <ul
                                data-testid="PersonalNavigationSection"
                                role="listbox"
                                className="list-headlessstyled__StyledList-sc-ca3ui9-1 cejUwb"
                              >
                                <li data-spacer="true" style={{ height: 4 }} />
                                <li
                                  data-index={0}
                                  data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOmU4NGNmNjA4LWExNWMtNGUwNi1hYjk4LTVlNDdiNDhlOTk0OA=="
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-1"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="FolderItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 fxmTMQ"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 iHfdzr">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="TeamspaceFolderIcon"
                                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                                  >
                                                    <path
                                                      fill=""
                                                      d="M1 3h14v11H1z"
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M1 0C.448 0 0 .478 0 1.067V13c0 1.178.895 2 2 2h12a2 2 0 0 0 2-2V4.267C16 3.088 15.105 2 14 2h-3.5L9.3.427A.98.98 0 0 0 8.5 0H1Zm13 5c0-.59-.448-1-1-1H3c-.552 0-1 .41-1 1v7c0 .59.448 1 1 1h10a1 1 0 0 0 1-1V5Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uRm9sZGVyOmU4NGNmNjA4LWExNWMtNGUwNi1hYjk4LTVlNDdiNDhlOTk0OA=="
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feature boards
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <div
                                                    display="flex"
                                                    className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                  >
                                                    <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="Folder-ContextMenu"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="DotsIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="add-Feature boardsboard-left-nav"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="PlusIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </div>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={1}
                                  data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOjRkYjkwNmM0LTNhNjktNGYwNi04Yzg2LTgyMjY4Y2I4NmJiZg=="
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-1"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="FolderItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 fxmTMQ"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 iHfdzr">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="TeamspaceFolderIcon"
                                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                                  >
                                                    <path
                                                      fill=""
                                                      d="M1 3h14v11H1z"
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M1 0C.448 0 0 .478 0 1.067V13c0 1.178.895 2 2 2h12a2 2 0 0 0 2-2V4.267C16 3.088 15.105 2 14 2h-3.5L9.3.427A.98.98 0 0 0 8.5 0H1Zm13 5c0-.59-.448-1-1-1H3c-.552 0-1 .41-1 1v7c0 .59.448 1 1 1h10a1 1 0 0 0 1-1V5Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uRm9sZGVyOjRkYjkwNmM0LTNhNjktNGYwNi04Yzg2LTgyMjY4Y2I4NmJiZg=="
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Roadmaps
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <div
                                                    display="flex"
                                                    className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                  >
                                                    <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="Folder-ContextMenu"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="DotsIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="add-Roadmapsboard-left-nav"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="PlusIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </div>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                              <div
                                data-testid="ListHeadless-KeyboardAnchor"
                                tabIndex={0}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="flexstyled__StyledFlex-sc-lvlevv-0 jbiJGI"
                        data-testid="DataMenu"
                      >
                        <div className="box__StyledBox-sc-b30x7m-0 kQacQF">
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                            <div
                              data-testid="MainMenuSection-Data"
                              className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                            >
                              <div
                                className="a6XhA2vk2hktu_NcQWh7"
                                role="heading"
                                data-testid="Group-Heading"
                              >
                                Data
                              </div>
                              <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                                <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="ChevronRightIcon"
                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <a
                          data-testid="StaticMenuItem"
                          tabIndex={0}
                          data-nc="true"
                          className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                          href="/data/drivers-scores"
                        >
                          <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                    <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DriverIcon"
                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M14 0H2c-.553 0-1 .447-1 .999V15a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V.999A1 1 0 0 0 14 0zM5 14H3v-2h2v2zm0-3.001H3V9h2v1.999zM5 8H3V6h2v2zm4 6H7v-2h2v2zm0-3.001H7V9h2v1.999zM9 8H7V6h2v2zm4 6h-2v-2h2v2zm0-3.001h-2V9h2v1.999zM13 8h-2V6h2v2zm0-4H3V2h10v2z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                  <div
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                  >
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                          <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                            <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                              Drivers &amp; Scores
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                    <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a
                          data-testid="StaticMenuItem"
                          tabIndex={0}
                          data-nc="true"
                          className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                          href="/data/releases"
                        >
                          <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                    <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="ReleaseIcon"
                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                      >
                                        <g fill="currentColor">
                                          <path d="M0 15a1 1 0 1 0 2 0V1a1 1 0 0 0-2 0v14z" />
                                          <path
                                            fillRule="evenodd"
                                            d="M15.793 1.588A.95.95 0 0 0 16 1c0-.552-.484-1-1.08-1H5.16C3.967 0 3 .895 3 2v7c0 1.105.967 2 2.16 2h9.76c.228 0 .45-.067.635-.191.483-.325.59-.95.238-1.397L13 5.5l2.793-3.912zM10.543 5.5l2.5-3.5H6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7.042l-2.5-3.5z"
                                            clipRule="evenodd"
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                  <div
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                  >
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                          <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                            <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                              Releases
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                    <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a
                          data-testid="StaticMenuItem"
                          tabIndex={0}
                          data-nc="true"
                          className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                          href="/data/tasks"
                        >
                          <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                    <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="TaskIcon"
                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14A6 6 0 0 1 8 2c1.809 0 3.426.803 4.525 2.068-.148.05-.289.125-.408.237L7.698 8.478 5.878 6.76a1.15 1.15 0 0 0-1.56 0 1 1 0 0 0 0 1.473l2.6 2.454a1.151 1.151 0 0 0 1.56 0l5.12-4.834C13.854 6.52 14 7.242 14 8a6 6 0 0 1-6 6z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                  <div
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                  >
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                          <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                            <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                              Tasks
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                    <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a
                          data-testid="StaticMenuItem"
                          tabIndex={0}
                          data-nc="true"
                          className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                          href="/data/default-fields"
                        >
                          <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                    <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                  <div
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                  >
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                          <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                            <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                              Default Fields
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                    <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className="main-menu__ScrollContainerFiller-sc-1px38at-3 jDUtYe" />
                    <div className="trial-progress__TrialProgressFooter-sc-1921okl-0 emEYZt">
                      <div className="expanded-trial-period__ExpandedWrapper-sc-hvxksn-0 guvfZL">
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 dGHbcT">
                          <div>
                            <span
                              data-nc="true"
                              className="textstyled__StyledText-sc-cx1866-0 byMfUs"
                            >
                              14
                            </span>{" "}
                            <span
                              data-nc="true"
                              className="textstyled__StyledText-sc-cx1866-0 eheNCz"
                            >
                              days left
                            </span>
                          </div>
                          <button
                            type="button"
                            data-nc="true"
                            className="button-primitive__StyledButton-sc-1guvopt-0 fkgSPA"
                          >
                            <span className="button-primitive__StyledContent-sc-1guvopt-1 jnjmlp">
                              <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                Buy now
                              </span>
                            </span>
                          </button>
                        </div>
                      </div>
                      <button
                        data-nc="true"
                        className="linkstyled__Link-sc-14qwv7c-0 fkgqsY"
                      >
                        <span className="linkstyled__Text-sc-14qwv7c-2 bdTmqZ">
                          Try different plan
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div
                  className=""
                  style={{
                    position: "absolute",
                    userSelect: "none",
                    width: 7,
                    height: "100%",
                    top: 0,
                    cursor: "col-resize",
                    right: "-3px"
                  }}
                >
                  <div
                    direction="vertical"
                    className="resize-handle__HandleContainer-sc-1idsfk7-1 hRNShL"
                  >
                    <div
                      direction="vertical"
                      className="resize-handle__HandleDivider-sc-1idsfk7-0 wxlNu"
                    />
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div className="WRgq_U97OawHo6EQhRRQ">
            <div className="animated-componentstyled__fade-sc-12t1a22-0 ecvVSH Mg_bVvVOl9HZYGa9blNT appear-done enter-done" />
          </div>
          <div data-hotkeys-layer="true" tabIndex={-1} />
          <div
            data-hotkeys-layer="true"
            tabIndex={-1}
            className="yBJwXyELiLiu7DixffkE"
          >
            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iCCEGT">
              <div className="header-container__Container-sc-1eys2lk-0 jCSzOb">
                <div className="flexstyled__StyledFlex-sc-lvlevv-0 hUBHRF">
                  <div className="header-primary__LeftContainer-sc-179e15q-0 ctEHxx">
                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jSxgqC">
                      <div className="header-primary__SelectableTitle-sc-179e15q-1 dHnedO">
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cquxeH">
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 iEFJYo">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 SgsON">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="TeamspaceIcon"
                                className="sc-11y93t1-0 cRyrkY ui-icon"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M3.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-9 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                                  fill=""
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M12 4c-1.2 0-2.2.5-2.9 1.3L6.9 4.2c.1-.2.1-.5.1-.7C7 1.6 5.4 0 3.5 0S0 1.6 0 3.5c0 1.4.8 2.6 2 3.1v2.7c-1.2.6-2 1.8-2 3.1 0 2 1.6 3.6 3.5 3.6S7 14.4 7 12.5c0-.2 0-.5-.1-.7L9 10.7c.8.8 1.8 1.3 3 1.3 2.2 0 4-1.8 4-4s-1.8-4-4-4ZM3.5 2C4.3 2 5 2.7 5 3.5S4.3 5 3.5 5 2 4.3 2 3.5 2.7 2 3.5 2Zm0 12c-.8 0-1.5-.7-1.5-1.5S2.7 11 3.5 11s1.5.7 1.5 1.5S4.3 14 3.5 14ZM6 10c-.5-.5-1.2-.9-2-1V6.9c.8-.1 1.5-.5 2-1L8.1 7c-.1.7-.1 1.3 0 1.9L6 10Zm6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
                                  fill="currentColor"
                                />
                              </svg>
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                  <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                    <h1
                                      data-nc="true"
                                      data-testid="header-name"
                                      className="heading__StyledHeading-sc-114dp0l-0 eDOqEr"
                                    >
                                      General
                                    </h1>
                                  </div>
                                </div>
                              </span>
                            </div>
                            <span
                              data-nc="true"
                              className="textstyled__StyledText-sc-cx1866-0 eyQANm"
                            >
                              /
                            </span>
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 fBNEaG">
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                  <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                    <h1
                                      data-nc="true"
                                      data-testid="header-name"
                                      className="heading__StyledHeading-sc-114dp0l-0 eDOqEr"
                                    >
                                      Feature boards
                                    </h1>
                                  </div>
                                </div>
                              </span>
                            </div>
                            <span
                              data-nc="true"
                              className="textstyled__StyledText-sc-cx1866-0 eyQANm"
                            >
                              /
                            </span>
                          </div>
                          <div className="renamable-title__Container-sc-1our1fr-0 ccjVcs">
                            <div className="editable-textstyled__StyledEditableText-sc-1r26pyp-0 hEcAMv">
                              <div
                                data-nc="true"
                                className="textstyled__StyledText-sc-cx1866-0 hWldxC"
                              >
                                <div className="editable-textstyled__StyledHiddenLabel-sc-1r26pyp-1 cOlZlT">
                                  <div className="editable-textstyled__StyledHiddenLabelInner-sc-1r26pyp-2 kCXWkG">
                                    <div className="truncate__TruncateWrapper-sc-11ftd2c-1 caVNcG">
                                      Feature prioritization (sample)
                                    </div>
                                  </div>
                                </div>
                                <div className="editable-textstyled__StyledAbsolute-sc-1r26pyp-3 cOwQwL">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <input
                                      data-testid="EditableBoardTitle"
                                      className="editable-textstyled__StyledEditableTextInput-sc-1r26pyp-4 iWIqyJ"
                                      defaultValue="Feature prioritization (sample)"
                                      style={{ width: 226 }}
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="favorite-container__Container-sc-19nndzy-0 cGskpP">
                        <div className="favorite-container__FavoriteContainerStyled-sc-19nndzy-1 fcwIws">
                          <div>
                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="StarIcon"
                                className="sc-11y93t1-0 xIpMQ ui-icon"
                              >
                                <g clipPath="url(#Star_svg__a)">
                                  <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    d="m8.467 11.11 2.531 1.331-.482-2.82a1 1 0 0 1 .287-.885l2.048-1.998-2.83-.41a.996.996 0 0 1-.753-.548L8 3.214 6.734 5.78a1 1 0 0 1-.753.547l-2.831.411 2.049 1.998a1 1 0 0 1 .287.885l-.483 2.82 2.532-1.33a.998.998 0 0 1 .932 0zm3.393 4.044L8 13.125l-3.86 2.03c-.726.386-1.591-.236-1.45-1.055l.737-4.299L.303 6.757a1 1 0 0 1 .555-1.706l4.316-.627L7.104.512c.337-.683 1.458-.683 1.794 0l1.93 3.911 4.317.627a1.001 1.001 0 0 1 .555 1.706l-3.124 3.045.736 4.3c.142.822-.726 1.435-1.451 1.053z"
                                    clipRule="evenodd"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="Star_svg__a">
                                    <path fill="#fff" d="M0 0h16v16H0z" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 wctrz">
                  <VeltCommentTool/>

                    <div
                      data-search-field-loading="false"
                      data-nc="true"
                      className="text-field-primitivestyled__Wrapper-sc-1ndan3b-0 fplKzA"
                    >
                      <div className="text-field-primitivestyled__Field-sc-1ndan3b-3 gHGzqM">
                        <span className="text-field-primitivestyled__IconWrapper-sc-1ndan3b-1 dUAWyH">
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 gNNPTr">
                            <svg
                              height="16px"
                              width="16px"
                              viewBox="0 0 16 16"
                              role="img"
                              aria-label="SearchIcon"
                              className="sc-11y93t1-0 xIpMQ ui-icon"
                              data-testid="Header-SearcField-SearchIcon"
                            >
                              <path
                                fill="currentColor"
                                fillRule="evenodd"
                                d="M15.546 15.546a1.5 1.5 0 0 1-2.121 0l-2.647-2.647a6.945 6.945 0 0 1-3.763 1.115 7 7 0 0 1 0-13.999 6.998 6.998 0 0 1 6.999 6.999 6.953 6.953 0 0 1-1.114 3.764l2.647 2.648a1.5 1.5 0 0 1-.001 2.12zM7.014 2.014a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </div>
                        </span>
                        <input
                          type="search"
                          placeholder="Search..."
                          autoComplete="off"
                          data-testid="Header-SearcField"
                          data-search-field-loading="false"
                          className="text-field-primitivestyled__StyledTextField-sc-1ndan3b-6 gbzXRE"
                          defaultValue=""
                        />
                      </div>
                    </div>
                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                      <button
                        type="button"
                        data-nc="true"
                        data-testid="Header-ShareButton"
                        className="button-primitive__StyledButton-sc-1guvopt-0 dcewKt"
                      >
                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                          <svg
                            height="16px"
                            width="16px"
                            viewBox="0 0 16 16"
                            role="img"
                            aria-label="ShareIcon"
                            className="sc-11y93t1-0 dqXaRM ui-icon"
                          >
                            <path
                              d="M1 16h14c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1h-3v2h2v7H2V7h2V5H1c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1Z"
                              fill="currentColor"
                            />
                            <path
                              d="M7.61 11a.6.6 0 0 1-.6-.6V4H5.086c-.525 0-.794-.6-.43-.96L7.56.174a.618.618 0 0 1 .86 0l2.9 2.866c.364.36.096.96-.43.96H9.01v6.4a.6.6 0 0 1-.6.6h-.8Z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                        <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                          <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                            Share
                          </span>
                        </span>
                      </button>
                    </span>
                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                      <button
                        type="button"
                        aria-label="Show more"
                        data-nc="true"
                        data-testid="Header-ContextMenu"
                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                      >
                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                          <svg
                            height="16px"
                            width="16px"
                            viewBox="0 0 16 16"
                            role="img"
                            aria-label="DotsIcon"
                            className="sc-11y93t1-0 dqXaRM ui-icon"
                          >
                            <path
                              fill="currentColor"
                              fillRule="evenodd"
                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                      </button>
                    </span>
                  </div>
                </div>
                <div className="header-secondary__Container-sc-wrzcoj-1 jjoxBj">
                  <div className="header-secondary__RelativeShift-sc-wrzcoj-0 iXlKLl">
                    <div className="header-secondary__ScrollableContainer-sc-wrzcoj-2 hdDHBa">
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                          <div className="kYtWvAzVL_GijpxOOJwF">
                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                              <span
                                className="UbyxfkCOwd0QZ6bPUFCA E_01Y9hYQrLNdc4jjOxz"
                                data-testid="BoardGrouping-Container"
                              >
                                <button
                                  type="button"
                                  data-nc="true"
                                  data-testid="grouping-button"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 ksTnjT"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="DuplicateIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M15 0H7c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 8H8V2h6v6zm-6 6H2V8h2V6H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-3H8v2z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                                    <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                      Grouped by: Hierarchy
                                    </span>
                                  </span>
                                </button>
                              </span>
                            </span>
                          </div>
                        </span>
                        <div className="board-filter-wrapperstyled__BoardFilterWrapper-sc-texokw-0 cYrnhR">
                          <div className="sc-1i3qtnn-0 kxgOFp">
                            <div
                              data-testid="BoardFilter-Filters-Icon"
                              className="sc-1i3qtnn-1 hXSezE"
                            >
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <button
                                  type="button"
                                  aria-label="Filter"
                                  data-nc="true"
                                  data-testid="filter-button"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 ksTnjT"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="FilterIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        d="M15 1H1v2h14V1zm-3 4H4v2h8V5zM6 9h4v2H6V9zm3 4H7v2h2v-2z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </div>
                                  <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                                    <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                      Filter
                                    </span>
                                  </span>
                                </button>
                              </span>
                              <div className="vu1IPbL1H8l1P3jRxAIV">
                                <div className="f5VSbGks1i8DxdDJ324f">
                                  <div
                                    className="T38TAHfZiSXZ3g792lHy QpwL7Zf7Rkfx5pd82gGz b9vFPwdzsj0M366THDp0"
                                    style={{ display: "none" }}
                                  >
                                    <span>+0</span>
                                    <div className="iTRjKj3YSDJ_uYHjNMJh pFc6ScbH9FPqyP6_nk1V" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 jJmdFf" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-layout__Content-sc-1u3l193-0 dnCWBw">
                <div
                  className="ylTMo5EH3cF8l80h46UG"
                  data-testid="FeaturesBoard-FloatingPlus-Wrapper"
                >
                  <div>
                    <div className="floating-actionstyled__StyledWrapper-sc-4rigmj-1 jrhhRX">
                      <div className="button-floating__StyledButtonWrapper-sc-1j4hk0u-0 OfgtE">
                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                          <button
                            type="button"
                            data-nc="true"
                            data-testid="FloatingAction-main"
                            className="button-primitive__StyledButton-sc-1guvopt-0 eFtOQb"
                          >
                            <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="PlusIcon"
                                className="sc-11y93t1-0 dqXaRM ui-icon"
                              >
                                <path
                                  fill="currentColor"
                                  fillRule="evenodd"
                                  d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </button>
                        </span>
                      </div>
                      <div className="floating-actionstyled__StyledMenu-sc-4rigmj-0 fFjTAz">
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 kxzJUm">
                          <div className="floating-actionstyled__StyledAnimateButton-sc-4rigmj-2 csFoYv">
                            <div className="button-floating__StyledButtonWrapper-sc-1j4hk0u-0 jOrLda">
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <button
                                  type="button"
                                  data-nc="true"
                                  data-testid="FloatingAction-action"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 fnTnVj"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="ImportIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.998 14.999a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5.999h11.998V8a1 1 0 0 1 2 0v6.999Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M7.598 0a.6.6 0 0 0-.6.6V7H5.074c-.526 0-.794.6-.43.96l2.903 2.866a.618.618 0 0 0 .86 0l2.902-2.866c.364-.36.096-.96-.43-.96H8.998V.6a.6.6 0 0 0-.6-.6h-.8Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </div>
                                </button>
                              </span>
                            </div>
                          </div>
                          <div className="floating-actionstyled__StyledAnimateButton-sc-4rigmj-2 csFoZc">
                            <div className="button-floating__StyledButtonWrapper-sc-1j4hk0u-0 jOrLda">
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <button
                                  type="button"
                                  data-nc="true"
                                  data-testid="FloatingAction-action"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 fnTnVj"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="ProductIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 6v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6H2z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="VG3B4_4N4ejtcDTLKvGT CNtCrafaipgpEwtZ015M"
                  data-testid="FeaturesBoard-Container"
                >
                  <div className="DkhFZNfCrTa28bLL4ZY5">
                    <div className="GvaGmKB2XC9NGpLOqgyF">
                      <div className="VmnY2JClBtVTkI6ClPVq oKME8LxHC7nO4aM7GvO8">
                        <div
                          className="YJAHTe6a8sKX8IH1iK19"
                          style={{ width: 600 }}
                        >
                          <div className="ogWobSoSmnwIns9OtdIG">
                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                              <button
                                type="button"
                                aria-label="Add columns"
                                data-nc="true"
                                data-testid="FeatureBoard-AddColumns-Button"
                                className="button-primitive__StyledButton-sc-1guvopt-0 jUqlUi"
                              >
                                <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="ColumnsAddIcon"
                                    className="sc-11y93t1-0 dqXaRM ui-icon"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M5 3H3v10h2V3ZM3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M11 10a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M14 11a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h4ZM11 3h2v5a1 1 0 1 0 2 0V3a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v5a1 1 0 0 0 2 0V3Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </div>
                              </button>
                            </span>
                          </div>
                          <div className="FzehqZnns5XbNYbKcx_w fCnjdqs5OAyKrSb4c7gv">
                            <div className="feature-import-banner-inline-column-editingstyled__MainContainer-sc-1lfubw7-2 jNeZqy">
                              <div className="feature-import-banner-inline-column-editingstyled__CloseButtonWrapper-sc-1lfubw7-1 huYkhh">
                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="RemoveIcon"
                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M8 6.441 4.882 3.323a1.101 1.101 0 1 0-1.558 1.559L6.442 8l-3.119 3.118a1.102 1.102 0 1 0 1.559 1.56l3.119-3.12 3.118 3.119a1.102 1.102 0 1 0 1.558-1.559L9.559 8l3.119-3.118a1.102 1.102 0 0 0-1.56-1.56L8 6.443z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </span>
                              </div>
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 hMrgZ">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                  <img
                                    src="https://cdn.productboard.com/assets/63d8c62edb5b717247ab.png"
                                    alt=""
                                    className="feature-import-banner-inline-column-editingstyled__Illustration-sc-1lfubw7-3 fyexpV"
                                  />
                                </div>
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                  <div className="feature-import-banner-inline-column-editingstyled__TextContent-sc-1lfubw7-4 hISGui">
                                    <div className="feature-import-banner-inline-column-editingstyled__BannerHeading-sc-1lfubw7-0 JUxrn">
                                      <div
                                        data-nc="true"
                                        className="heading__StyledHeading-sc-114dp0l-0 bckMDB"
                                      >
                                        Already have a backlog?
                                      </div>
                                    </div>
                                    <p
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 dlYLYb"
                                    >
                                      Import feature ideas easily from your
                                      favorite tools
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="vGc5KWhc9GuNHYWEqieG"
                          data-testid="FeaturesBoard-ColumnSectionWrapper"
                          style={{
                            transform: "translate3d(0px, 0px, 0px)",
                            width: 746
                          }}
                        >
                          <div
                            className="UkZ4wEvo2xJ1SGxcd7pb columnGroupHeader column-group-id-7508888"
                            style={{ width: 108, left: 0 }}
                          >
                            <div
                              className="owUJiLemkSITc6Jsauyc"
                              data-testid="FeaturesBoard-ColumnGroupHeader-Wrapper"
                            >
                              <button className="sc-1wmv0qx-1 dpJjBh">
                                <span
                                  data-nc="true"
                                  className="textstyled__StyledText-sc-cx1866-0 blXKZm"
                                >
                                  Drivers
                                </span>
                                <div className="sc-1wmv0qx-0 ibVmVZ">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="ArrowCaretIcon"
                                    className="sc-11y93t1-0 kqDcRj ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M5.25 7.495C4.75 6.997 5 6 6 6h3.995c1.005 0 1.256.995.755 1.495l-2 2.205c-.45.4-1.05.4-1.498 0L5.25 7.495z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </button>
                            </div>
                            <div className="U9LfFkFGd_EURohehsmp">
                              <div
                                id="column-header-60588888"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588888 business-goal columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 108, left: 0 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Value
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="UkZ4wEvo2xJ1SGxcd7pb columnGroupHeader column-group-id-7508890"
                            style={{ width: 116, left: 108 }}
                          >
                            <div
                              className="owUJiLemkSITc6Jsauyc"
                              data-testid="FeaturesBoard-ColumnGroupHeader-Wrapper"
                            >
                              <span className="hkoxfXQcfykztTpZj62o CZvDKpQt0KXVUoUukLFA" />
                            </div>
                            <div className="U9LfFkFGd_EURohehsmp">
                              <div
                                id="column-header-60588892"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588892 complexity columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 116, left: 0 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Effort
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="UkZ4wEvo2xJ1SGxcd7pb columnGroupHeader column-group-id-7508896"
                            style={{ width: 116, left: 224 }}
                          >
                            <div
                              className="owUJiLemkSITc6Jsauyc"
                              data-testid="FeaturesBoard-ColumnGroupHeader-Wrapper"
                            >
                              <span className="hkoxfXQcfykztTpZj62o CZvDKpQt0KXVUoUukLFA" />
                            </div>
                            <div className="U9LfFkFGd_EURohehsmp">
                              <div
                                id="column-header-60588900"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588900 calculated columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 116, left: 0 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Value/Effort Score
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="UkZ4wEvo2xJ1SGxcd7pb columnGroupHeader column-group-id-7508907"
                            style={{ width: 214, left: 340 }}
                          >
                            <div
                              className="owUJiLemkSITc6Jsauyc"
                              data-testid="FeaturesBoard-ColumnGroupHeader-Wrapper"
                            >
                              <span className="hkoxfXQcfykztTpZj62o CZvDKpQt0KXVUoUukLFA" />
                            </div>
                            <div className="U9LfFkFGd_EURohehsmp">
                              <div
                                id="column-header-60588939"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588939 timeframe columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 214, left: 0 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Timeframe
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="UkZ4wEvo2xJ1SGxcd7pb columnGroupHeader column-group-id-7508901"
                            style={{ width: 192, left: 554 }}
                          >
                            <div
                              className="owUJiLemkSITc6Jsauyc"
                              data-testid="FeaturesBoard-ColumnGroupHeader-Wrapper"
                            >
                              <button className="sc-1wmv0qx-1 dpJjBh">
                                <span
                                  data-nc="true"
                                  className="textstyled__StyledText-sc-cx1866-0 blXKZm"
                                >
                                  releases
                                </span>
                                <div className="sc-1wmv0qx-0 ibVmVZ">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="ArrowCaretIcon"
                                    className="sc-11y93t1-0 kqDcRj ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M5.25 7.495C4.75 6.997 5 6 6 6h3.995c1.005 0 1.256.995.755 1.495l-2 2.205c-.45.4-1.05.4-1.498 0L5.25 7.495z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </button>
                            </div>
                            <div className="U9LfFkFGd_EURohehsmp">
                              <div
                                id="column-header-60588936"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588936 release columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 96, left: 0 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Sprint 1
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                              <div
                                id="column-header-60588937"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588937 release columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 96, left: 96 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Sprint 2
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="YTMpFgNm73jhqHP2SZoc"
                      style={{ position: "relative" }}
                    >
                      <div className="PErwaA01Evv3LcPYu08a">
                        <div
                          id="board-content-scrollable"
                          className="e9daayaM3ttdq9eeku8L"
                          style={{ height: 609 }}
                        >
                          <div className="Yq6w5Hj3EyeQDOgLNRVn cAjUk9R1Q0h6dkUOpIiO">
                            <div className="djltbc7b1dng7rc79ur6" />
                            <div
                              className="LDjKwCEV9BMsiRj0h4ke"
                              style={{ height: 280 }}
                            >
                              <div
                                className="i79VdW0TOO35s6Cjcjkk"
                                style={{ width: 600 }}
                              >
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 240px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF qrIsn7rzNPE5XXPGC4ks fv8EdGx2kAuBHCTk8tIw">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 0 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                        <div
                                          className="TmmXjAETbbMouL8IAKDW"
                                          data-testid="FeaturesBoard-QuickAddTopLevel-Section"
                                        >
                                          <svg
                                            viewBox="0 0 16 16"
                                            className="d4YepzgP4Fg1HL37LKoH oMiYLvQo1yWeDHfp87d2 pb-icon"
                                          >
                                            <path d="M8 .001A8 8 0 108 16 8 8 0 008 0zm0 13.998c-3.308 0-5.999-2.691-5.999-5.999S4.692 2.001 8 2.001c3.309 0 6 2.691 6 5.999s-2.691 5.999-6 5.999zM11.01 7H9V4.99A.99.99 0 008.01 4h-.02a.99.99 0 00-.99.99V7H4.991A.99.99 0 004 7.99v.02c0 .548.444.99.991.99H7v2.01c0 .547.443.989.99.989h.02c.547 0 .99-.442.99-.989V9h2.01a.99.99 0 00.99-.99v-.02a.99.99 0 00-.99-.99z" />
                                          </svg>
                                          <span className="laO7VtVMWVolUtBiX8Xb">
                                            Add new product
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 40px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 0 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym WRuy66_eD9irWr5yPEnZ">
                                        <div
                                          data-testid="DraggableCanvasElement"
                                          style={{
                                            display: "flex",
                                            width: "100%"
                                          }}
                                        >
                                          <div className="lMYiaxEEatguUeYOeeAc tRv3BP4B1YVJ_wyCevMz">
                                            <div
                                              className="OZEMH4mCtKdrSk6JTcc9"
                                              style={{ width: 78 }}
                                            >
                                              <div style={{ width: 26 }} />
                                              <div style={{ width: 26 }}>
                                                <div
                                                  className="toggle-icons nShXrmNDePDgKtZR4OE9"
                                                  data-testid="FeaturesBoard-RowExpansionToggle-Uncollapsed"
                                                >
                                                  <svg
                                                    viewBox="0 0 10 6"
                                                    className="oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                  >
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M4.205 5.682L.308 1.851a1.07 1.07 0 010-1.533 1.115 1.115 0 011.558 0l3.118 3.065L8.102.318a1.117 1.117 0 011.56 0c.43.423.43 1.11 0 1.533L5.764 5.682a1.116 1.116 0 01-1.559 0z"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                              <div style={{ width: 26 }}>
                                                <div className="l306g84_3PfGluK5_5Vx DTr0s9r9bOaG3Cka3EAP">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <svg
                                                      viewBox="0 0 16 16"
                                                      className="s5guO22DVnFd_AK1mWP7 oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                      data-testid="FeatureIcon-component"
                                                    >
                                                      <path
                                                        d="M2 0h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2H2C.9 7 0 6.1 0 5V2C0 .9.9 0 2 0zm9 0h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2zm0 9h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2zM2 9h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2z"
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                      />
                                                    </svg>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className="FceG8Z_9tHBcXeYC6xyG xC1qSemCbaxIHEtwsMZO TUHHEueWsY63UAzvEJ_M"
                                              data-testid="FeaturesBoard-FeatureTitle-Cell"
                                            >
                                              <a
                                                className="t5jTNpP6pQB0K8JLPt15 Nq9AmJoJXi8lN7fDSa3L"
                                                draggable="false"
                                                title="Component (helps organize feature ideas)"
                                                href="/feature-board/7450406-feature-prioritization-sample/features/24723140/detail"
                                              >
                                                <span className="s0c4fLqv8QRGYgMjE0Tm">
                                                  Component (helps organize
                                                  feature ideas)
                                                </span>
                                              </a>
                                            </div>
                                            <div />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 120px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 26 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym">
                                        <div
                                          data-testid="DraggableCanvasElement"
                                          style={{
                                            display: "flex",
                                            width: "100%"
                                          }}
                                        >
                                          <div className="lMYiaxEEatguUeYOeeAc tRv3BP4B1YVJ_wyCevMz">
                                            <div
                                              className="OZEMH4mCtKdrSk6JTcc9"
                                              style={{ width: 78 }}
                                            >
                                              <div style={{ width: 26 }} />
                                              <div style={{ width: 26 }} />
                                              <div style={{ width: 26 }}>
                                                <div className="l306g84_3PfGluK5_5Vx DTr0s9r9bOaG3Cka3EAP">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <svg
                                                      viewBox="0 0 16 16"
                                                      className="O4k_TaPk0Yyar4vmBDk4 uduOF4IAC8pwfDSf6HnG oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                      data-testid="FeatureIcon-feature"
                                                    >
                                                      <path d="M4 0h8c2.2 0 4 1.8 4 4v8c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z" />
                                                    </svg>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className="FceG8Z_9tHBcXeYC6xyG TUHHEueWsY63UAzvEJ_M"
                                              data-testid="FeaturesBoard-FeatureTitle-Cell"
                                            >
                                              <a
                                                className="t5jTNpP6pQB0K8JLPt15 Nq9AmJoJXi8lN7fDSa3L"
                                                draggable="false"
                                                title="Sample feature 2"
                                                href="/feature-board/7450406-feature-prioritization-sample/features/24723142/detail"
                                              >
                                                <span className="s0c4fLqv8QRGYgMjE0Tm">
                                                  Sample feature 2
                                                </span>
                                              </a>
                                            </div>
                                            <div />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 80px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 26 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym">
                                        <div
                                          data-testid="DraggableCanvasElement"
                                          style={{
                                            display: "flex",
                                            width: "100%"
                                          }}
                                        >
                                          <div className="lMYiaxEEatguUeYOeeAc tRv3BP4B1YVJ_wyCevMz">
                                            <div
                                              className="OZEMH4mCtKdrSk6JTcc9"
                                              style={{ width: 78 }}
                                            >
                                              <div style={{ width: 26 }} />
                                              <div style={{ width: 26 }} />
                                              <div style={{ width: 26 }}>
                                                <div className="l306g84_3PfGluK5_5Vx DTr0s9r9bOaG3Cka3EAP">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <svg
                                                      viewBox="0 0 16 16"
                                                      className="O4k_TaPk0Yyar4vmBDk4 uduOF4IAC8pwfDSf6HnG oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                      data-testid="FeatureIcon-feature"
                                                    >
                                                      <path d="M4 0h8c2.2 0 4 1.8 4 4v8c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z" />
                                                    </svg>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className="FceG8Z_9tHBcXeYC6xyG TUHHEueWsY63UAzvEJ_M"
                                              data-testid="FeaturesBoard-FeatureTitle-Cell"
                                            >
                                              <a
                                                className="t5jTNpP6pQB0K8JLPt15 Nq9AmJoJXi8lN7fDSa3L"
                                                draggable="false"
                                                title="Sample feature 1"
                                                href="/feature-board/7450406-feature-prioritization-sample/features/24723141/detail"
                                              >
                                                <span className="s0c4fLqv8QRGYgMjE0Tm">
                                                  Sample feature 1
                                                </span>
                                              </a>
                                            </div>
                                            <div />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 0px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 0 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                        <div
                                          data-testid="DraggableCanvasElement"
                                          style={{
                                            display: "flex",
                                            width: "100%"
                                          }}
                                        >
                                          <div className="lMYiaxEEatguUeYOeeAc tRv3BP4B1YVJ_wyCevMz">
                                            <div
                                              className="OZEMH4mCtKdrSk6JTcc9"
                                              style={{ width: 52 }}
                                            >
                                              <div style={{ width: 26 }}>
                                                <div
                                                  className="toggle-icons nShXrmNDePDgKtZR4OE9"
                                                  data-testid="FeaturesBoard-RowExpansionToggle-Uncollapsed"
                                                >
                                                  <svg
                                                    viewBox="0 0 10 6"
                                                    className="oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                  >
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M4.205 5.682L.308 1.851a1.07 1.07 0 010-1.533 1.115 1.115 0 011.558 0l3.118 3.065L8.102.318a1.117 1.117 0 011.56 0c.43.423.43 1.11 0 1.533L5.764 5.682a1.116 1.116 0 01-1.559 0z"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                              <div style={{ width: 26 }}>
                                                <div className="l306g84_3PfGluK5_5Vx DTr0s9r9bOaG3Cka3EAP">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <div className="s5guO22DVnFd_AK1mWP7 KN9abFoAWIjcnMtAkAc3">
                                                      <svg
                                                        height="16px"
                                                        width="16px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="ProductIcon"
                                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                                      >
                                                        <path
                                                          fill="currentColor"
                                                          fillRule="evenodd"
                                                          d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 6v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6H2z"
                                                          clipRule="evenodd"
                                                        />
                                                      </svg>
                                                    </div>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className="FceG8Z_9tHBcXeYC6xyG HslGqOpDjaxSq43m4LkI TUHHEueWsY63UAzvEJ_M"
                                              data-testid="FeaturesBoard-FeatureTitle-Cell"
                                            >
                                              <a
                                                className="t5jTNpP6pQB0K8JLPt15 Nq9AmJoJXi8lN7fDSa3L"
                                                draggable="false"
                                                title="Velt"
                                                href="/feature-board/7450406-feature-prioritization-sample/features/24723139/detail"
                                              >
                                                <span className="s0c4fLqv8QRGYgMjE0Tm">
                                                  Velt
                                                </span>
                                              </a>
                                            </div>
                                            <div />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 160px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 26 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym">
                                        <div
                                          data-testid="DraggableCanvasElement"
                                          style={{
                                            display: "flex",
                                            width: "100%"
                                          }}
                                        >
                                          <div className="lMYiaxEEatguUeYOeeAc tRv3BP4B1YVJ_wyCevMz">
                                            <div
                                              className="OZEMH4mCtKdrSk6JTcc9"
                                              style={{ width: 78 }}
                                            >
                                              <div style={{ width: 26 }} />
                                              <div style={{ width: 26 }} />
                                              <div style={{ width: 26 }}>
                                                <div className="l306g84_3PfGluK5_5Vx DTr0s9r9bOaG3Cka3EAP">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <svg
                                                      viewBox="0 0 16 16"
                                                      className="O4k_TaPk0Yyar4vmBDk4 uduOF4IAC8pwfDSf6HnG oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                      data-testid="FeatureIcon-feature"
                                                    >
                                                      <path d="M4 0h8c2.2 0 4 1.8 4 4v8c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z" />
                                                    </svg>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className="FceG8Z_9tHBcXeYC6xyG TUHHEueWsY63UAzvEJ_M"
                                              data-testid="FeaturesBoard-FeatureTitle-Cell"
                                            >
                                              <a
                                                className="t5jTNpP6pQB0K8JLPt15 Nq9AmJoJXi8lN7fDSa3L"
                                                draggable="false"
                                                title="Sample feature 3"
                                                href="/feature-board/7450406-feature-prioritization-sample/features/24723143/detail"
                                              >
                                                <span className="s0c4fLqv8QRGYgMjE0Tm">
                                                  Sample feature 3
                                                </span>
                                              </a>
                                            </div>
                                            <div />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 200px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 0 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                        <div
                                          data-testid="DraggableCanvasElement"
                                          style={{
                                            display: "flex",
                                            width: "100%"
                                          }}
                                        >
                                          <div className="lMYiaxEEatguUeYOeeAc tRv3BP4B1YVJ_wyCevMz">
                                            <div
                                              className="OZEMH4mCtKdrSk6JTcc9"
                                              style={{ width: 52 }}
                                            >
                                              <div style={{ width: 26 }}>
                                                <div
                                                  className="toggle-icons nShXrmNDePDgKtZR4OE9 toggle-icons--is-collapsed"
                                                  data-testid="FeaturesBoard-RowExpansionToggle-Collapsed"
                                                >
                                                  <svg
                                                    viewBox="0 0 10 6"
                                                    className="oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                  >
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M4.205 5.682L.308 1.851a1.07 1.07 0 010-1.533 1.115 1.115 0 011.558 0l3.118 3.065L8.102.318a1.117 1.117 0 011.56 0c.43.423.43 1.11 0 1.533L5.764 5.682a1.116 1.116 0 01-1.559 0z"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                              <div style={{ width: 26 }}>
                                                <div className="l306g84_3PfGluK5_5Vx DTr0s9r9bOaG3Cka3EAP">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <div className="s5guO22DVnFd_AK1mWP7 KN9abFoAWIjcnMtAkAc3">
                                                      <svg
                                                        height="16px"
                                                        width="16px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="ProductIcon"
                                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                                      >
                                                        <path
                                                          fill="currentColor"
                                                          fillRule="evenodd"
                                                          d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 6v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6H2z"
                                                          clipRule="evenodd"
                                                        />
                                                      </svg>
                                                    </div>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className="FceG8Z_9tHBcXeYC6xyG HslGqOpDjaxSq43m4LkI TUHHEueWsY63UAzvEJ_M"
                                              data-testid="FeaturesBoard-FeatureTitle-Cell"
                                            >
                                              <a
                                                className="t5jTNpP6pQB0K8JLPt15 Nq9AmJoJXi8lN7fDSa3L"
                                                draggable="false"
                                                title="Zlack Messaging App (sample product)"
                                                href="/feature-board/7450406-feature-prioritization-sample/features/24723121/detail"
                                              >
                                                <span className="s0c4fLqv8QRGYgMjE0Tm">
                                                  Zlack Messaging App (sample
                                                  product)
                                                </span>
                                              </a>
                                            </div>
                                            <div />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="E1cl9ZdQjNJgZ75A27av"
                                data-testid="FeaturesBoard-LazyRender-ColumnGroupSection"
                                style={{
                                  left: 600,
                                  transform: "translate3d(0px, 0px, 0px)",
                                  width: 1028
                                }}
                              >
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 40px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym WRuy66_eD9irWr5yPEnZ">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl lLVGliUNW_LNbu_zP1CW"
                                        style={{ width: 746 }}
                                      >
                                        <div
                                          className="group column-group-id-7508888"
                                          style={{
                                            width: 108,
                                            left: 0,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="2d934233-2682-46dc-97a0-0b0900641889"
                                            className="cell column-id-60588888 business-goal"
                                            style={{ left: 0, width: 108 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"90%",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="2d934233-2682-46dc-97a0-0b0900641889"/>
                                              </div>
                                            </div>
                                            <div className="aF9XPq4LWvQCB9dTQ8IU lbJhv9xMBlTkDQBEp2SA">
                                              <div className="a_OWnu3F8Bkot8b2DIn8">
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508890"
                                          style={{
                                            width: 116,
                                            left: 108,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="f880223f-e03e-407e-a6ba-fb9463323590"
                                            className="cell column-id-60588892 complexity"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"90%",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="f880223f-e03e-407e-a6ba-fb9463323590"/>
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="NmXKRvKPipQtwJnJe7EC">
                                                <div className="F3L39I1O_d5WCbboTNWA ghTFqSeeFOqX2lTIiFsd GIElcwnzpnqXYrPcnHop">
                                                  0
                                                </div>

                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q" />
=
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508896"
                                          style={{
                                            width: 116,
                                            left: 224,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          
                                          <div
                                            id="ff3"
                                            className="cell column-id-60588900 calculated"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"90%",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff3"/>
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="NmXKRvKPipQtwJnJe7EC">
                                                <div className="F3L39I1O_d5WCbboTNWA ghTFqSeeFOqX2lTIiFsd GIElcwnzpnqXYrPcnHop">
                                                  0
                                                </div>
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508907"
                                          style={{
                                            width: 214,
                                            left: 340,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="ff4"
                                            className="cell column-id-60588939 timeframe"
                                            style={{ left: 0, width: 214 }}
                                          />
                                          <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff4"/>
                                              </div>
                                            </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508901"
                                          style={{
                                            width: 192,
                                            left: 554,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="ff5"
                                            className="cell column-id-60588936 release"
                                            style={{ left: 0, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"90%",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff5"/>
                                              </div>
                                            </div>
                                            <div className="aF9XPq4LWvQCB9dTQ8IU lbJhv9xMBlTkDQBEp2SA">
                                              <div className="a_OWnu3F8Bkot8b2DIn8">
                                                <div className="YmlT4jYR7t46nePGsbFD">
                                                  <svg
                                                    className="XxSWcBxGbJHjnpyApPVN"
                                                    height={26}
                                                    width={26}
                                                  >
                                                    <circle
                                                      className="vCSgAN_qqKxydxAbPbEw"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                    />
                                                    <circle
                                                      className="uj0z8FzG6eYxag7DYlXR"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                      style={{
                                                        strokeDasharray:
                                                          "75.3982, 75.3982",
                                                        strokeDashoffset:
                                                          "75.3982"
                                                      }}
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            id="ff6"
                                            className="cell column-id-60588937 release"
                                            style={{ left: 96, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff6"/>
                                              </div>
                                            </div>
                                            <div className="aF9XPq4LWvQCB9dTQ8IU lbJhv9xMBlTkDQBEp2SA">
                                              <div className="a_OWnu3F8Bkot8b2DIn8">
                                                <div className="YmlT4jYR7t46nePGsbFD">
                                                  <svg
                                                    className="XxSWcBxGbJHjnpyApPVN"
                                                    height={26}
                                                    width={26}
                                                  >
                                                    <circle
                                                      className="vCSgAN_qqKxydxAbPbEw"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                    />
                                                    <circle
                                                      className="uj0z8FzG6eYxag7DYlXR"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                      style={{
                                                        strokeDasharray:
                                                          "75.3982, 75.3982",
                                                        strokeDashoffset:
                                                          "75.3982"
                                                      }}
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 120px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl lLVGliUNW_LNbu_zP1CW"
                                        style={{ width: 746 }}
                                      >
                                        <div
                                          className="group column-group-id-7508888"
                                          style={{
                                            width: 108,
                                            left: 0,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="ff7"
                                            className="cell column-id-60588888 business-goal"
                                            style={{ left: 0, width: 108 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff7"/>
                                              </div>
                                            </div>
                                            <div className="sc-1vpki97-0 dwYuAg">
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 izyxRS" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 izyxRS" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 mrqER" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 mrqER" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 mrqER" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508890"
                                          style={{
                                            width: 116,
                                            left: 108,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="ff8"
                                            className="cell column-id-60588892 complexity"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff8"/>
                                              </div>
                                            </div>
                                            <div
                                              className="ZYHmw2rIacHYnimk0s0B"
                                              data-testid="ComplexityNumber-Container"
                                            >
                                              <div
                                                className="Oybn5g7l3q_89fa35M_q c14AP9qgw15eKp4kd_a0"
                                                data-testid="ComplexityNumber-Value"
                                              >
                                                1
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508896"
                                          style={{
                                            width: 116,
                                            left: 224,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="ff9"
                                            className="cell column-id-60588900 calculated"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff9"/>
                                              </div>
                                            </div>
                                            <div className="XdHYk7Iyu51s8IMxOMQ6">
                                              <div className="r9KKOT4oYHigNTKY1Ko6 tMVaaSOzVykiVTBKGU_1">
                                                <div className="NmXKRvKPipQtwJnJe7EC">
                                                  <div className="F3L39I1O_d5WCbboTNWA">
                                                    40
                                                  </div>
                                                  <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q">
                                                    <div
                                                      className="Xbs3YLGgSp_z4RbjRPgL"
                                                      style={{
                                                        backgroundColor:
                                                          "rgb(148, 199, 250)"
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508907"
                                          style={{
                                            width: 214,
                                            left: 340,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="ff10"
                                            className="cell column-id-60588939 timeframe"
                                            style={{ left: 0, width: 214 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff10"/>
                                              </div>
                                            </div>
                                            <div className="sc-c3602i-0 bvDBRl">
                                              <div className="sc-c3602i-1 bmbOky">
                                                <div
                                                  data-testid="timeframe-value"
                                                  className="timeframe-valuestyled__Container-sc-ia8xov-0 gTUoBr"
                                                >
                                                  <div className="timeframe-valuestyled__Wrapper-sc-ia8xov-2 hWdTKq">
                                                    <div className="timeframe-valuestyled__FixedWidth-sc-ia8xov-3 hOwnXN">
                                                      <span
                                                        data-testid="Sidebar-Timeframe-FromLabel"
                                                        data-nc="true"
                                                        className="textstyled__StyledText-sc-cx1866-0 cIhsfB"
                                                      >
                                                        <div className="timeframe-valuestyled__Transition-sc-ia8xov-1 ernMrX">
                                                          Mar 17, 2024
                                                        </div>
                                                      </span>
                                                    </div>
                                                    <div className="timeframe-valuestyled__IconWrapper-sc-ia8xov-4 zypFL">
                                                      <svg
                                                        height="12px"
                                                        width="12px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="ArrowLongRightIcon"
                                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                                      >
                                                        <path
                                                          fill="currentColor"
                                                          d="M2 8.379a.6.6 0 0 0 .6.6H10v1.923c0 .526.6.795.96.43l2.866-2.902a.618.618 0 0 0 0-.86L10.96 4.668c-.36-.365-.96-.096-.96.43v1.88H2.6a.6.6 0 0 0-.6.6v.8z"
                                                        />
                                                      </svg>
                                                    </div>
                                                    <div className="timeframe-valuestyled__FixedWidth-sc-ia8xov-3 hOwnXN">
                                                      <span
                                                        data-testid="Sidebar-Timeframe-ToLabel"
                                                        data-nc="true"
                                                        className="textstyled__StyledText-sc-cx1866-0 cIhsfB"
                                                      >
                                                        <div className="timeframe-valuestyled__Transition-sc-ia8xov-1 ernMrX">
                                                          Apr 13, 2024
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508901"
                                          style={{
                                            width: 192,
                                            left: 554,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="ff11"
                                            className="cell column-id-60588936 release"
                                            style={{ left: 0, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff11"/>
                                              </div>
                                            </div>
                                            <div className="jaolQaf1JcynjHW2l7ki">
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div
                                                  data-testid="FeaturesBoard-ReleaseAssignment-Circle"
                                                  className="sc-554tku-1 hmrSBU"
                                                />
                                              </span>
                                            </div>
                                          </div>
                                          <div
                                            id="ff12"
                                            className="cell column-id-60588937 release"
                                            style={{ left: 96, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff12"/>
                                              </div>
                                            </div>
                                            <div className="jaolQaf1JcynjHW2l7ki">
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div
                                                  data-testid="FeaturesBoard-ReleaseAssignmentIcon-Wrapper"
                                                  className="sc-554tku-0 cyoxTf"
                                                >
                                                  <svg
                                                    viewBox="0 0 26 26"
                                                    className="oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                  >
                                                    <path d="M17.7 9.3c-.4-.5-1.1-.5-1.6 0l-4.4 4.8-1.8-2c-.4-.5-1.1-.5-1.6 0-.4.5-.4 1.2 0 1.7l2.6 2.8c.4.5 1.1.5 1.6 0l5.2-5.6c.4-.4.4-1.2 0-1.7M13 26C5.8 26 0 20.2 0 13S5.8 0 13 0s13 5.8 13 13-5.8 13-13 13" />
                                                  </svg>
                                                </div>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 80px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl lLVGliUNW_LNbu_zP1CW"
                                        style={{ width: 746 }}
                                      >
                                        <div
                                          className="group column-group-id-7508888"
                                          style={{
                                            width: 108,
                                            left: 0,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="ff13"
                                            className="cell column-id-60588888 business-goal"
                                            style={{ left: 0, width: 108 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff13"/>
                                              </div>
                                            </div>
                                            <div className="sc-1vpki97-0 dwYuAg">
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 izyxRS" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 izyxRS" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 izyxRS" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 izyxRS" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 mrqER" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508890"
                                          style={{
                                            width: 116,
                                            left: 108,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="ff14"
                                            className="cell column-id-60588892 complexity"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="ff14"/>
                                              </div>
                                            </div>
                                            <div
                                              className="ZYHmw2rIacHYnimk0s0B"
                                              data-testid="ComplexityNumber-Container"
                                            >
                                              <div
                                                className="Oybn5g7l3q_89fa35M_q c14AP9qgw15eKp4kd_a0"
                                                data-testid="ComplexityNumber-Value"
                                              >
                                                5
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508896"
                                          style={{
                                            width: 116,
                                            left: 224,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="gg1"
                                            className="cell column-id-60588900 calculated"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="gg1"/>
                                              </div>
                                            </div>
                                            <div className="XdHYk7Iyu51s8IMxOMQ6">
                                              <div className="r9KKOT4oYHigNTKY1Ko6 tMVaaSOzVykiVTBKGU_1">
                                                <div className="NmXKRvKPipQtwJnJe7EC">
                                                  <div className="F3L39I1O_d5WCbboTNWA">
                                                    16
                                                  </div>
                                                  <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q">
                                                    <div
                                                      className="Xbs3YLGgSp_z4RbjRPgL"
                                                      style={{
                                                        backgroundColor:
                                                          "rgb(148, 199, 250)"
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508907"
                                          style={{
                                            width: 214,
                                            left: 340,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="gg2"
                                            className="cell column-id-60588939 timeframe"
                                            style={{ left: 0, width: 214 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="gg2"/>
                                              </div>
                                            </div>
                                            <div className="sc-c3602i-0 bvDBRl">
                                              <div className="sc-c3602i-1 bmbOky">
                                                <div
                                                  data-testid="timeframe-value"
                                                  className="timeframe-valuestyled__Container-sc-ia8xov-0 gTUoBr"
                                                >
                                                  <div className="timeframe-valuestyled__Wrapper-sc-ia8xov-2 hWdTKq">
                                                    <div className="timeframe-valuestyled__FixedWidth-sc-ia8xov-3 hOwnXN">
                                                      <span
                                                        data-testid="Sidebar-Timeframe-FromLabel"
                                                        data-nc="true"
                                                        className="textstyled__StyledText-sc-cx1866-0 cIhsfB"
                                                      >
                                                        <div className="timeframe-valuestyled__Transition-sc-ia8xov-1 ernMrX">
                                                          Nov 12, 2023
                                                        </div>
                                                      </span>
                                                    </div>
                                                    <div className="timeframe-valuestyled__IconWrapper-sc-ia8xov-4 zypFL">
                                                      <svg
                                                        height="12px"
                                                        width="12px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="ArrowLongRightIcon"
                                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                                      >
                                                        <path
                                                          fill="currentColor"
                                                          d="M2 8.379a.6.6 0 0 0 .6.6H10v1.923c0 .526.6.795.96.43l2.866-2.902a.618.618 0 0 0 0-.86L10.96 4.668c-.36-.365-.96-.096-.96.43v1.88H2.6a.6.6 0 0 0-.6.6v.8z"
                                                        />
                                                      </svg>
                                                    </div>
                                                    <div className="timeframe-valuestyled__FixedWidth-sc-ia8xov-3 hOwnXN">
                                                      <span
                                                        data-testid="Sidebar-Timeframe-ToLabel"
                                                        data-nc="true"
                                                        className="textstyled__StyledText-sc-cx1866-0 cIhsfB"
                                                      >
                                                        <div className="timeframe-valuestyled__Transition-sc-ia8xov-1 ernMrX">
                                                          Dec 9, 2023
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508901"
                                          style={{
                                            width: 192,
                                            left: 554,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="gg3"
                                            className="cell column-id-60588936 release"
                                            style={{ left: 0, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="gg3"/>
                                              </div>
                                            </div>
                                            <div className="jaolQaf1JcynjHW2l7ki">
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div
                                                  data-testid="FeaturesBoard-ReleaseAssignmentIcon-Wrapper"
                                                  className="sc-554tku-0 cyoxTf"
                                                >
                                                  <svg
                                                    viewBox="0 0 26 26"
                                                    className="oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                  >
                                                    <path d="M17.7 9.3c-.4-.5-1.1-.5-1.6 0l-4.4 4.8-1.8-2c-.4-.5-1.1-.5-1.6 0-.4.5-.4 1.2 0 1.7l2.6 2.8c.4.5 1.1.5 1.6 0l5.2-5.6c.4-.4.4-1.2 0-1.7M13 26C5.8 26 0 20.2 0 13S5.8 0 13 0s13 5.8 13 13-5.8 13-13 13" />
                                                  </svg>
                                                </div>
                                              </span>
                                            </div>
                                          </div>
                                          <div
                                            id="gg4"
                                            className="cell column-id-60588937 release"
                                            style={{ left: 96, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="gg4"/>
                                              </div>
                                            </div>
                                            <div className="jaolQaf1JcynjHW2l7ki">
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div
                                                  data-testid="FeaturesBoard-ReleaseAssignment-Circle"
                                                  className="sc-554tku-1 hmrSBU"
                                                />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 0px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl lLVGliUNW_LNbu_zP1CW"
                                        style={{ width: 746 }}
                                      >
                                        <div
                                          className="group column-group-id-7508888"
                                          style={{
                                            width: 108,
                                            left: 0,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="gg5"
                                            className="cell column-id-60588888 business-goal"
                                            style={{ left: 0, width: 108 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="gg5"/>
                                              </div>
                                            </div>
                                            <div className="aF9XPq4LWvQCB9dTQ8IU lbJhv9xMBlTkDQBEp2SA">
                                              <div className="a_OWnu3F8Bkot8b2DIn8">
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508890"
                                          style={{
                                            width: 116,
                                            left: 108,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="gg6"
                                            className="cell column-id-60588892 complexity"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="gg6"/>
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="NmXKRvKPipQtwJnJe7EC">
                                                <div className="F3L39I1O_d5WCbboTNWA ghTFqSeeFOqX2lTIiFsd GIElcwnzpnqXYrPcnHop">
                                                  0
                                                </div>
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508896"
                                          style={{
                                            width: 116,
                                            left: 224,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="gg7"
                                            className="cell column-id-60588900 calculated"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="gg7"/>
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="NmXKRvKPipQtwJnJe7EC">
                                                <div className="F3L39I1O_d5WCbboTNWA ghTFqSeeFOqX2lTIiFsd GIElcwnzpnqXYrPcnHop">
                                                  0
                                                </div>
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508907"
                                          style={{
                                            width: 214,
                                            left: 340,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="gg9"
                                            className="cell column-id-60588939 timeframe"
                                            style={{ left: 0, width: 214 }}
                                          />
                                          <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="gg9"/>
                                              </div>
                                            </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508901"
                                          style={{
                                            width: 192,
                                            left: 554,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="gg10"
                                            className="cell column-id-60588936 release"
                                            style={{ left: 0, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="gg10"/>
                                              </div>
                                            </div>
                                            <div className="aF9XPq4LWvQCB9dTQ8IU lbJhv9xMBlTkDQBEp2SA">
                                              <div className="a_OWnu3F8Bkot8b2DIn8">
                                                <div className="YmlT4jYR7t46nePGsbFD">
                                                  <svg
                                                    className="XxSWcBxGbJHjnpyApPVN"
                                                    height={26}
                                                    width={26}
                                                  >
                                                    <circle
                                                      className="vCSgAN_qqKxydxAbPbEw"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                    />
                                                    <circle
                                                      className="uj0z8FzG6eYxag7DYlXR"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                      style={{
                                                        strokeDasharray:
                                                          "75.3982, 75.3982",
                                                        strokeDashoffset:
                                                          "75.3982"
                                                      }}
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            id="hh1"
                                            className="cell column-id-60588937 release"
                                            style={{ left: 96, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="hh1"/>
                                              </div>
                                            </div>
                                            <div className="aF9XPq4LWvQCB9dTQ8IU lbJhv9xMBlTkDQBEp2SA">
                                              <div className="a_OWnu3F8Bkot8b2DIn8">
                                                <div className="YmlT4jYR7t46nePGsbFD">
                                                  <svg
                                                    className="XxSWcBxGbJHjnpyApPVN"
                                                    height={26}
                                                    width={26}
                                                  >
                                                    <circle
                                                      className="vCSgAN_qqKxydxAbPbEw"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                    />
                                                    <circle
                                                      className="uj0z8FzG6eYxag7DYlXR"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                      style={{
                                                        strokeDasharray:
                                                          "75.3982, 75.3982",
                                                        strokeDashoffset:
                                                          "75.3982"
                                                      }}
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 240px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF qrIsn7rzNPE5XXPGC4ks fv8EdGx2kAuBHCTk8tIw">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl"
                                        style={{ width: 746 }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 200px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl lLVGliUNW_LNbu_zP1CW"
                                        style={{ width: 746 }}
                                      >
                                        <div
                                          className="group column-group-id-7508888"
                                          style={{
                                            width: 108,
                                            left: 0,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="hh2"
                                            className="cell column-id-60588888 business-goal"
                                            style={{ left: 0, width: 108 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="hh2"/>
                                              </div>
                                            </div>
                                            <div className="aF9XPq4LWvQCB9dTQ8IU lbJhv9xMBlTkDQBEp2SA">
                                              <div className="a_OWnu3F8Bkot8b2DIn8">
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q Aw8yI4cS_ExyO8xfN9UN" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508890"
                                          style={{
                                            width: 116,
                                            left: 108,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="hh3"
                                            className="cell column-id-60588892 complexity"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="hh3"/>
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="NmXKRvKPipQtwJnJe7EC">
                                                <div className="F3L39I1O_d5WCbboTNWA ghTFqSeeFOqX2lTIiFsd GIElcwnzpnqXYrPcnHop">
                                                  0
                                                </div>
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508896"
                                          style={{
                                            width: 116,
                                            left: 224,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="hh4"
                                            className="cell column-id-60588900 calculated"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="hh4"/>
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="NmXKRvKPipQtwJnJe7EC">
                                                <div className="F3L39I1O_d5WCbboTNWA ghTFqSeeFOqX2lTIiFsd GIElcwnzpnqXYrPcnHop">
                                                  0
                                                </div>
                                                <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508907"
                                          style={{
                                            width: 214,
                                            left: 340,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="hh5"
                                            className="cell column-id-60588939 timeframe"
                                            style={{ left: 0, width: 214 }}
                                          />
                                          <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="hh5"/>
                                              </div>
                                            </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508901"
                                          style={{
                                            width: 192,
                                            left: 554,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="hh6"
                                            className="cell column-id-60588936 release"
                                            style={{ left: 0, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="hh6"/>
                                              </div>
                                            </div>
                                            <div className="aF9XPq4LWvQCB9dTQ8IU lbJhv9xMBlTkDQBEp2SA">
                                              <div className="a_OWnu3F8Bkot8b2DIn8">
                                                <div className="YmlT4jYR7t46nePGsbFD">
                                                  <svg
                                                    className="XxSWcBxGbJHjnpyApPVN"
                                                    height={26}
                                                    width={26}
                                                  >
                                                    <circle
                                                      className="vCSgAN_qqKxydxAbPbEw"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                    />
                                                    <circle
                                                      className="uj0z8FzG6eYxag7DYlXR"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                      style={{
                                                        strokeDasharray:
                                                          "75.3982, 75.3982",
                                                        strokeDashoffset:
                                                          "75.3982"
                                                      }}
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            id="hh7"
                                            className="cell column-id-60588937 release"
                                            style={{ left: 96, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="hh7"/>
                                              </div>
                                            </div>
                                            <div className="aF9XPq4LWvQCB9dTQ8IU lbJhv9xMBlTkDQBEp2SA">
                                              <div className="a_OWnu3F8Bkot8b2DIn8">
                                                <div className="YmlT4jYR7t46nePGsbFD">
                                                  <svg
                                                    className="XxSWcBxGbJHjnpyApPVN"
                                                    height={26}
                                                    width={26}
                                                  >
                                                    <circle
                                                      className="vCSgAN_qqKxydxAbPbEw"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                    />
                                                    <circle
                                                      className="uj0z8FzG6eYxag7DYlXR"
                                                      r={12}
                                                      fill="transparent"
                                                      cx={13}
                                                      cy={13}
                                                      style={{
                                                        strokeDasharray:
                                                          "75.3982, 75.3982",
                                                        strokeDashoffset:
                                                          "75.3982"
                                                      }}
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 160px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl lLVGliUNW_LNbu_zP1CW"
                                        style={{ width: 746 }}
                                      >
                                        <div
                                          className="group column-group-id-7508888"
                                          style={{
                                            width: 108,
                                            left: 0,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="hh9"
                                            className="cell column-id-60588888 business-goal"
                                            style={{ left: 0, width: 108 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="hh9"/>
                                              </div>
                                            </div>
                                            <div className="sc-1vpki97-0 dwYuAg">
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 izyxRS" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 izyxRS" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 izyxRS" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 mrqER" />
                                              </span>
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div className="sc-1vpki97-1 mrqER" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508890"
                                          style={{
                                            width: 116,
                                            left: 108,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="yy1"
                                            className="cell column-id-60588892 complexity"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="yy1"/>
                                              </div>
                                            </div>
                                            <div
                                              className="ZYHmw2rIacHYnimk0s0B"
                                              data-testid="ComplexityNumber-Container"
                                            >
                                              <div
                                                className="Oybn5g7l3q_89fa35M_q c14AP9qgw15eKp4kd_a0"
                                                data-testid="ComplexityNumber-Value"
                                              >
                                                3
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508896"
                                          style={{
                                            width: 116,
                                            left: 224,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="yy2"
                                            className="cell column-id-60588900 calculated"
                                            style={{ left: 0, width: 116 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="yy2"/>
                                              </div>
                                            </div>
                                            <div className="XdHYk7Iyu51s8IMxOMQ6">
                                              <div className="r9KKOT4oYHigNTKY1Ko6 tMVaaSOzVykiVTBKGU_1">
                                                <div className="NmXKRvKPipQtwJnJe7EC">
                                                  <div className="F3L39I1O_d5WCbboTNWA">
                                                    20
                                                  </div>
                                                  <div className="QXwBoVGJxuqZWYjx4LJV pNQGfehHdJDd4rGGYM0Q">
                                                    <div
                                                      className="Xbs3YLGgSp_z4RbjRPgL"
                                                      style={{
                                                        backgroundColor:
                                                          "rgb(148, 199, 250)"
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508907"
                                          style={{
                                            width: 214,
                                            left: 340,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="yy3"
                                            className="cell column-id-60588939 timeframe"
                                            style={{ left: 0, width: 214 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="yy3"/>
                                              </div>
                                            </div>
                                            <div className="sc-c3602i-0 bvDBRl">
                                              <div className="sc-c3602i-1 bmbOky">
                                                <div
                                                  data-testid="timeframe-value"
                                                  className="timeframe-valuestyled__Container-sc-ia8xov-0 gTUoBr"
                                                >
                                                  <div className="timeframe-valuestyled__Wrapper-sc-ia8xov-2 hWdTKq">
                                                    <div className="timeframe-valuestyled__FixedWidth-sc-ia8xov-3 hOwnXN">
                                                      <span
                                                        data-testid="Sidebar-Timeframe-FromLabel"
                                                        data-nc="true"
                                                        className="textstyled__StyledText-sc-cx1866-0 cIhsfB"
                                                      >
                                                        <div className="timeframe-valuestyled__Transition-sc-ia8xov-1 ernMrX">
                                                          Nov 24, 2023
                                                        </div>
                                                      </span>
                                                    </div>
                                                    <div className="timeframe-valuestyled__IconWrapper-sc-ia8xov-4 zypFL">
                                                      <svg
                                                        height="12px"
                                                        width="12px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="ArrowLongRightIcon"
                                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                                      >
                                                        <path
                                                          fill="currentColor"
                                                          d="M2 8.379a.6.6 0 0 0 .6.6H10v1.923c0 .526.6.795.96.43l2.866-2.902a.618.618 0 0 0 0-.86L10.96 4.668c-.36-.365-.96-.096-.96.43v1.88H2.6a.6.6 0 0 0-.6.6v.8z"
                                                        />
                                                      </svg>
                                                    </div>
                                                    <div className="timeframe-valuestyled__FixedWidth-sc-ia8xov-3 hOwnXN">
                                                      <span
                                                        data-testid="Sidebar-Timeframe-ToLabel"
                                                        data-nc="true"
                                                        className="textstyled__StyledText-sc-cx1866-0 cIhsfB"
                                                      >
                                                        <div className="timeframe-valuestyled__Transition-sc-ia8xov-1 ernMrX">
                                                          Dec 23, 2023
                                                        </div>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="group column-group-id-7508901"
                                          style={{
                                            width: 192,
                                            left: 554,
                                            position: "absolute",
                                            display: "inline-block"
                                          }}
                                        >
                                          <div
                                            id="yy4"
                                            className="cell column-id-60588936 release"
                                            style={{ left: 0, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="yy4"/>
                                              </div>
                                            </div>
                                            <div className="jaolQaf1JcynjHW2l7ki">
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div
                                                  data-testid="FeaturesBoard-ReleaseAssignment-Circle"
                                                  className="sc-554tku-1 hmrSBU"
                                                />
                                              </span>
                                            </div>
                                          </div>
                                          <div
                                            id="zz1"
                                            className="cell column-id-60588937 release"
                                            style={{ left: 96, width: 96 }}
                                          >
                                            <div className="commentToolContainer" style={{display:"flex", height:"30px",width:"90%", zIndex:"100", position:"absolute", justifyContent:"flex-end"}}>
                                              <div className='hide' style={{position:"absolute", zIndex:"100"}}>
                                                <VeltCommentTool  targetCommentElementId="zz1"/>
                                              </div>
                                            </div>
                                            <div className="jaolQaf1JcynjHW2l7ki">
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <div
                                                  data-testid="FeaturesBoard-ReleaseAssignmentIcon-Wrapper"
                                                  className="sc-554tku-0 cyoxTf"
                                                >
                                                  <svg
                                                    viewBox="0 0 26 26"
                                                    className="oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                  >
                                                    <path d="M17.7 9.3c-.4-.5-1.1-.5-1.6 0l-4.4 4.8-1.8-2c-.4-.5-1.1-.5-1.6 0-.4.5-.4 1.2 0 1.7l2.6 2.8c.4.5 1.1.5 1.6 0l5.2-5.6c.4-.4.4-1.2 0-1.7M13 26C5.8 26 0 20.2 0 13S5.8 0 13 0s13 5.8 13 13-5.8 13-13 13" />
                                                  </svg>
                                                </div>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="H55jh5YCAb9uSVrao9Fq"
                              style={{
                                height: "100%",
                                left: 600,
                                transform: "translate3d(0px, 0px, 0px)"
                              }}
                            >
                              <div
                                className="gPXF0Bod4goR4xYad1tw column-group-id-7508888"
                                style={{ left: 0, display: "block" }}
                              />
                              <div
                                className="gPXF0Bod4goR4xYad1tw column-group-id-7508890"
                                style={{ left: 108, display: "block" }}
                              />
                              <div
                                className="gPXF0Bod4goR4xYad1tw column-group-id-7508896"
                                style={{ left: 224, display: "block" }}
                              />
                              <div
                                className="gPXF0Bod4goR4xYad1tw column-group-id-7508907"
                                style={{ left: 340, display: "block" }}
                              />
                              <div
                                className="gPXF0Bod4goR4xYad1tw column-group-id-7508901"
                                style={{ left: 554, display: "block" }}
                              />
                            </div>
                            <div className="QvBpcxid9PXlip8YiQDJ" />
                            <div id="visualization-portal" />
                            <div
                              className="ehk4JteljVmJ67dSNIYl"
                              style={{
                                transform: "translate3d(600px, 0px, 0px)"
                              }}
                            />
                            <div style={{ height: 150 }} />
                          </div>
                        </div>
                      </div>
                      <div
                        className="DYUadK9NU0sQZ8Vyku9y"
                        style={{ transform: "translate3d(600px, 0px, 0px)" }}
                      >
                        <div className="hIIoOL4prkZlPxYCDT8O">
                          <div style={{ position: "relative", width: 365 }}>
                            <div className="horizontal-scrollbarstyled__ScrollbarArea-sc-1uwgsfu-0 hsaLeN">
                              <div
                                className="horizontal-scrollbarstyled__Scrollbar-sc-1uwgsfu-1 iVNUxr"
                                style={{ left: 0, width: "35%" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="sc-yk0mva-1 hueKlo"
                      style={{ transform: "translate3d(600px, 0px, 0px)" }}
                    />
                    <div
                      data-testid="DraggableCanvasElement"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        bottom: 0,
                        zIndex: 2
                      }}
                    >
                      <div
                        className="sc-yk0mva-2 aEkbR"
                        style={{ transform: "translate3d(600px, 0px, 0px)" }}
                      >
                        <div className="sc-yk0mva-0 kxSyrl" />
                      </div>
                    </div>
                    <div className="sc-yk0mva-3 jTAuVT" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="YPhjEfZFRZNuqGKZkVg4" data-testid="Sidebar-Menu" />
          <div className="sc-1rpu86o-0 iiizaW">
            <div id="floating-actions" className="sc-1rpu86o-1 dQtPHH" />
            <div className="sc-1rpu86o-2 keUbDp">
              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                <a data-testid="HelpMenu-Button" className="sc-ya26g2-1 jfftCp">
                  <svg
                    height="16px"
                    width="16px"
                    viewBox="0 0 16 16"
                    role="img"
                    aria-label="QuestionMarkIcon"
                    className="sc-11y93t1-0 jMzzJy ui-icon"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.88 11.67h2.357V14H6.88v-2.33ZM5.57 2.613C6.193 2.204 6.954 2 7.859 2c1.189 0 2.175.29 2.962.87.785.58 1.18 1.44 1.18 2.579 0 .699-.17 1.287-.512 1.765-.201.29-.582.66-1.15 1.113l-.556.444c-.305.24-.508.523-.606.845-.063.204-.099.521-.104.95H6.934c.031-.907.116-1.534.253-1.88.136-.347.487-.746 1.054-1.197l.575-.46c.188-.145.34-.304.455-.475.21-.297.314-.621.314-.977 0-.407-.117-.78-.35-1.115-.232-.337-.66-.504-1.278-.504-.609 0-1.04.207-1.296.62a2.432 2.432 0 0 0-.381 1.29H4c.063-1.531.587-2.617 1.57-3.256Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              </span>
            </div>
          </div>
        </div>
        <div id="popup" />
        <div id="deprecated_tooltip" />
        <div id="tooltip" />
        <div id="snippet-popup-portal" />
        <div id="helper-portal" />
        <div id="dropdown-portal" />
        <div id="modal-portal" />
        <div id="portal-card-detail" />
        <div id="onboarding_tooltip" />
      </div>
    </div>
    <div
      style={{
        position: "fixed",
        zIndex: 7000002,
        inset: 16,
        pointerEvents: "none"
      }}
    />
  </section>
  <iframe
    data-product="web_widget"
    title="No content"
    role="presentation"
    tabIndex={-1}
    allow="microphone *"
    aria-hidden="true"
    src="about:blank"
    style={{
      width: 0,
      height: 0,
      border: 0,
      position: "absolute",
      top: "-9999px"
    }}
  />
  <div>
    <iframe
      title="Opens a widget where you can chat to one of our agents"
      id="launcher"
      tabIndex={0}
      style={{
        colorScheme: "light",
        width: 0,
        height: 50,
        padding: 0,
        margin: "10px 20px",
        position: "fixed",
        bottom: 0,
        overflow: "visible",
        opacity: 1,
        border: 0,
        zIndex: 999998,
        transitionDuration: "250ms",
        transitionTimingFunction: "cubic-bezier(0.645, 0.045, 0.355, 1)",
        transitionProperty: "opacity, top, bottom",
        right: 0
      }}
    />
  </div>
  <iframe
    name="__privateStripeMetricsController5520"
    frameBorder={0}
    allowTransparency="true"
    scrolling="no"
    role="presentation"
    allow="payment *"
    src="https://js.stripe.com/v3/m-outer-27c67c0d52761104439bb051c7856ab1.html#url=https%3A%2F%2Fvelt.productboard.com&title=Feature%20launch%20roadmap%20(sample)%20-%20Roadmap%20%7C%20Productboard&referrer=&muid=99400dc8-947a-4e4a-9489-8682ef4f957bb38a6d&sid=d02fc07e-1b77-42d3-88b3-02c55e755386077441&version=6&preview=false&metaReferrerPolicy=origin"
    aria-hidden="true"
    tabIndex={-1}
    style={{
      border: "none !important",
      margin: "0px !important",
      padding: "0px !important",
      width: "1px !important",
      minWidth: "100% !important",
      overflow: "hidden !important",
      display: "block !important",
      visibility: "hidden !important",
      position: "fixed !important",
      height: "1px !important",
      pointerEvents: "none !important",
      userSelect: "none !important"
    }}
  />
  <div id="DndDescribedBy-0" style={{ display: "none" }}>
    To pick up a draggable item, press the space bar. While dragging, use the
    arrow keys to move the item. Press space again to drop the item in its new
    position, or press escape to cancel.
  </div>
  <div
    id="DndLiveRegion-0"
    role="status"
    aria-live="assertive"
    aria-atomic="true"
    style={{
      position: "absolute",
      width: 1,
      height: 1,
      margin: "-1px",
      border: 0,
      padding: 0,
      overflow: "hidden",
      clip: "rect(0px, 0px, 0px, 0px)",
      clipPath: "inset(100%)",
      whiteSpace: "nowrap"
    }}
  />
  <div id="DndDescribedBy-1" style={{ display: "none" }}>
    To pick up a draggable item, press the space bar. While dragging, use the
    arrow keys to move the item. Press space again to drop the item in its new
    position, or press escape to cancel.
  </div>
  <div
    id="DndLiveRegion-1"
    role="status"
    aria-live="assertive"
    aria-atomic="true"
    style={{
      position: "absolute",
      width: 1,
      height: 1,
      margin: "-1px",
      border: 0,
      padding: 0,
      overflow: "hidden",
      clip: "rect(0px, 0px, 0px, 0px)",
      clipPath: "inset(100%)",
      whiteSpace: "nowrap"
    }}
  />
  <iframe
    id="intercom-frame"
    style={{
      position: "absolute !important",
      opacity: "0 !important",
      width: "1px !important",
      height: "1px !important",
      top: "0 !important",
      left: "0 !important",
      border: "none !important",
      display: "block !important",
      zIndex: "-1 !important",
      pointerEvents: "none"
    }}
    aria-hidden="true"
    tabIndex={-1}
    title="Intercom"
  />
  <div
    id="batBeacon83092431037"
    style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
  >
    <img
      id="batBeacon111004039211"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&pi=918639831&lg=en-US&sw=1512&sh=982&sc=30&tl=Feature%20launch%20roadmap%20(sample)%20%7C%20Productboard&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&r=&lt=235&evt=pageLoad&sv=1&rn=692169"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon793750754800"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=App%20loaded%20all%20smarter%20json%20data&el2=App%20loaded%20all%20smarter%20json%20data&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=875440"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon712466234392"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=User%20load%20javascript&el2=User%20load%20javascript&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=174806"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon539615855302"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=User%20load%20all%20perf&el2=User%20load%20all%20perf&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=975341"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon856451182522"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Smarter%20json%20mvb%20data%20loaded&el2=Smarter%20json%20mvb%20data%20loaded&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=152047"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon821036860226"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=App%20shell%20loaded&el2=App%20shell%20loaded&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=65815"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon462848422659"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=User%20load%20perf&el2=User%20load%20perf&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=958140"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon820485085316"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Mvb%20rendered&el2=Mvb%20rendered&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=261069"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon192213863539"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Roadmap%20board%20viewed&el2=Roadmap%20board%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=55629"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon253716572893"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Trial%20upgrade%20prompt%20shown&el2=Trial%20upgrade%20prompt%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=792135"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon829656310874"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Trial%20upgrade%20prompt%20shown&el2=Trial%20upgrade%20prompt%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=517116"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon251915420584"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Board%20opened&el2=Board%20opened&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample&sw=1512&sh=982&sc=30&evt=custom&rn=251645"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon375767394481"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Features%20board%20viewed&el2=Features%20board%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample&sw=1512&sh=982&sc=30&evt=custom&rn=483685"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon758407355824"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Share%20view%20button%20viewed&el2=Share%20view%20button%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample&sw=1512&sh=982&sc=30&evt=custom&rn=117367"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon34310427193"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Feature%20import%20banner%20shown&el2=Feature%20import%20banner%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample&sw=1512&sh=982&sc=30&evt=custom&rn=686569"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon782625446826"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=144f2669-313c-4947-855e-f2e7587bba97&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Features%20board%20rendered&el2=Features%20board%20rendered&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample&sw=1512&sh=982&sc=30&evt=custom&rn=331632"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
  </div>
  <div className="intercom-lightweight-app" />
  <div id="rvNiWyVRbzxC" style={{ display: "none" }} />
</>

  )
}
